import React, {useState, useEffect, useRef} from "react";
import {connect} from "react-redux";

// ------------ Lib ------------------
import _, {set} from "lodash";
import moment from "moment";

// ------------ Components ------------
import {Modal as CustomModal} from "@redq/reuse-modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {Table} from "react-bootstrap";
// import CheckBox from "../../components/Checkbox/Checkboxs";
import {Link} from "react-router-dom";
import Button from "react-bootstrap/Button";
import EmailIcon from "@material-ui/icons/Email";
import MotorcycleTwoTone from "@material-ui/icons/MotorcycleTwoTone";
import {green} from "@material-ui/core/colors";
import Loader from "../../components/Loader/Loader";
import {Form, Modal, Pagination, InputGroup, Spinner, Toast} from "react-bootstrap";
import {RemoveRedEye, Edit, Filter, Refresh} from "@material-ui/icons";
import HistoryIcon from "@material-ui/icons/History"
import Datetime from 'react-datetime';
import {Dialog,Table as MTable ,DialogActions, DialogContent, DialogContentText, DialogTitle, Checkbox, IconButton, Tooltip, TextField, TableCell, TableRow, Chip, TableBody, Paper, TableContainer, TableHead, LinearProgress, TablePagination} from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import FilterNoneIcon from '@material-ui/icons/FilterNone';

// -------------- APIs ---------------
import API from "../../network/dashboardAPI";

// -------------- State Action -------------
import {getOrders} from "../../store/actions/dashboardAction";

// -------------- Style --------------
import styled from "styled-components";
import "react-datetime/css/react-datetime.css";
import { order } from "styled-system";


//-------------- Json as Xlsx --------------
import xlsx from "json-as-xlsx"
import AvailableDeliverySlotModal from "../../components/AvailableDeliverySlot/AvailableDeliverySlotModal";
import UpdateAvailableDeliverySlotModal from "../../components/UpdateAvailableDeliverySlot/UpdateAvailableDeliverySlotModal";
import Can from "../../components/Allow/Can";

const HelpPageWrapper = styled.div`
  background-color: #f7f7f7;
  position: relative;
  padding: 50px 0 50px 0;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 989px) {
    padding-top: 70px;
  }
`;

const TableContent = styled.div`
	table {
		thead tr th {
			width: initial;
			vertical-align: middle;
      font-weight: 700;
      font-size: 0.95rem;
      background: #efefef;
		}

		tbody tr td {
      vertical-align: middle;
      white-space: nowrap;
      font-size: 0.95rem;
      
      &.modified {
        color: #ff963e; 

        &.allowedPaymentMethod {
          & > * {
            color: #ff963e;
            border-color: #ff963e;
          }
        }
      }
		}
	}

  .MuiDialogContent-dividers {
    padding: 16px;
  }

  .MuiTableContainer-root {
    ::-webkit-scrollbar {
      width: 9px;
      height: 9px;
      border-radius: 3px;
    }
  
    ::-webkit-scrollbar-thumb {
      background: #dee2e6;
      border-radius: 3px;

      &:hover {
        background: #9c9a9a;
      }
    }
  }

`;
const TableBodyWidth = styled.div`
  table tr th {
    white-space: nowrap;
    width: initial;
  }
`;

const labelStyle = {
  lineHeight: "2.5rem",
  width: "14rem",
};

const success = "success";
const secondary = "secondary";
const UpArrow = "↑";
const DownArrow = "↓";
const UpDownArrow = "↑↓";

const defaultStartDate = moment(new Date()).startOf('day').format("YYYY-MM-DD HH:mm:ss");
const defaultEndDate = moment(new Date()).endOf('day').format("YYYY-MM-DD HH:mm:ss");
const date = new Date(), y = date.getFullYear(), m = date.getMonth();
const Orders = (props) => {
      const startDateFilterRef = useRef("");
      const endDateFilterRef = useRef("");

      // ------------------ Status -----------------------
      const [accept, setAccept] = useState(true);
      const [dispatch, setDispatch] = useState(true);
      const [query, setQuery] = useState(false);
      const [orderIDs, setOrderIDs] = useState([]);
      const [status, setStatus] = useState(2345678);
      const [isSelected, setIsSelected] = useState(false);
      const [sortFlag, setSortFlag] = useState(true);
      const [orderArrow, setOrderArrow] = useState(false);
      const [amountArrow, setAmountArrow] = useState(false);
      const [dateArrow, setDateArrow] = useState(false);
      const [orderList, setOrderList] = useState([]);
      const [isRequesting, setIsRequesting] = useState(false);
      const [isProductRequest, setIsProductRequest] = useState(false);
      const [totalNumberList, setTotalNumberList] = useState(0);
      const [isOpenModalAddDriver, setIsOpenModalAddDriver] = useState(false);
      const [validated, setValidated] = useState(false);
      const [driverList, setDriverList] = useState([]);
      const [selectedDriver, setSelectedDriver] = useState("");
      const [isAllowAddDriver, setIsAllowAddDriver] = useState(true);
      const [orderUpdate, setOrderUpdate] = useState({});
      const [isShowOnlyAcceptedHasDriver, setIsShowOnlyAcceptedHasDriver] =
          useState(false);
      const [orderStatusCount, setOrderStatusCount] = useState({});
      const [isShowConfirmModal, setIsShowConfirmModal] = useState(false);
      const [isShowConfirmModalOrder, setIsShowConfirmModalOrder] = useState(false);
      const [orderIdToCancel, setOrderIdToCancel] = useState("");
      const [orderToViewWallet, setOrderToViewWallet] = useState({});
      const [selectedStatus, setSelectedStatus] = useState(0);
		const [updatingSlot, setUpdatingSlot] = useState(false)
      const [orderStatusOpts, setOrderStatusOpts] = useState([
        {
          label: "All status",
          value: {status: 2345678, isShowAccptedHasDriver: false},
        },
        {label: "New", value: {status: 2, isShowAccptedHasDriver: false}},
        {label: "Accepted", value: {status: 3, isShowAccptedHasDriver: false}},
        {
          label: "Assigned to driver",
          value: {status: 3, isShowAccptedHasDriver: true},
        },
        {
          label: "Packed & On the way",
          value: {status: 45, isShowAccptedHasDriver: false},
        },
        {
          label: "Delivered",
          value: {status: 6, isShowAccptedHasDriver: false},
        },
        {label: "Arrived", value: {status: 8, isShowAccptedHasDriver: false}},
        {label: "Cancelled", value: {status: 7, isShowAccptedHasDriver: false}},
        {label: "Waiting Payment", value: {status: -1, isShowAccptedHasDriver: false}},
      ]);
      const [selectedBasketType, setSelectedBasketType] = useState("");
      const [textSearch, setTextSearch] = useState("");
      const [startDate, setStartDate] = useState("");
      const [endDate, setEndDate] = useState("");
      const [startDateDefault, setStartDateDefault] = useState(moment(new Date(y, m, 1)).format("YYYY-MM-DD"));
      const [endDateDefault, setEndDateDefault] = useState(moment(new Date(y, m + 1, 0)).format("YYYY-MM-DD"));

      // pagination states
      const [next, setNext] = useState(0);
      const [limit, setLimit] = useState(30);
      const [prev, setPrev] = useState(0);
      const [pager, setPager] = useState(1);

      //value option extract report
      const [value, setValue] = useState("0");
      

      // Loading states
      const [isRequestingUpsert, setIsRequestingUpsert] = useState(false);

      // Wallet list data
      const [walletTransactionList, setWalletTransactionList] = useState([]);

      // Wallet form data
      const [transactionType, setTransactionType] = useState("credit");
      const [walletOwnerId, setWalletOwnerId] = useState("");
      const [reason, setReason] = useState("refund");
      const [walletAmount, setWalletAmount] = useState(0);
      const [comment, setComment] = useState("");
      const [orderNumber, setOrderNumber] = useState("");
      const [walletFormError, setWalletFormError] = useState({
        walletAmount: false,
        comment: false,
        reason: false,
        transactionType: false,
      });
      const [orderToAddWallet, setOrderToAddWallet] = useState({});
      const [isWalletRequesting, setIsWalletRequesting] = useState(false);

      // toast states
      const [toastBgColor, setToastBgColor] = useState('bg-success');
      const [showToast, setShowToast] = useState(false);
      const [toastMessage, setToastMessage] = useState("Delete successful");

      // Wallet modal data
      const [isShowAddWalletTranModal, setIsShowAddWalletTranModal] =
          useState(false);
      const [isShowWalletTransactionModal, setIsShowWalletTransactionModal] =
          useState(false);

      // Sort
      const [orderField, setOrderField] = useState("status");
      const [orderType, setOrderType] = useState("ASC");
      const [orderTypeOpts, setOrderTypeOpts] = useState(["DESC", "ASC"]);


      // Filter states
      const [startDateFilter, setStartDateFilter] = useState("");
      const [endDateFilter, setEndDateFilter] = useState("");

      // Modal confirm send file
      const [isOpenModalConfirmSendFile, setIsOpenModalConfirmSendFile] = useState(false);
      const [isRequestingSendFile, setIsRequestingSendFile] = useState(false);
      const [orderIdToSendFile, setOrderIdToSendFile] = useState("");

      // Modal confirm send pickup file
      const [isOpenModalConfirmPickupFile, setIsOpenModalConfirmPickupFile] = useState(false);
      const [isRequestingSendPickupFile, setIsRequestingSendPickupFile] = useState(false);

      // Modal confirm send multi invoice/order file
      const [isOpenModalConfirmSendMultiInvoiceFile, setIsOpenModalConfirmfSendMultiInvoiceFile] = useState(false);
      const [isRequestingSendMultiInvoiceFile, setIsRequestingSendMultiInvoiceFile] = useState(false);
      
      //extract report
      const [isOpenModalExtractReport, setIsOpenModalExtractReport] = useState(false);

      // Query
      const [modalQueryOpen, setModalQueryOpen] = useState(false);
      const [queryOrderId, setQueryOrderId] = useState(null);
      const [queryData, setQueryData] = useState({});
      const [queryLoading, setQueryLoading] = useState([]);
      const [queryDisable, setQueryDisable] = useState(false);

		const [selectedSlot, setSelectedSlot] = useState(0);
		const [selectedOrder, setSelectedOrder] = useState({});
      const [showSchedule, setShowSchedule] = useState(false);

      // update slot and history
      const [slotHistoryModal, setSlotHistoryModal] = useState(false);
      const [selectedUpdateSlot, setSelectedUpdateSlot] = useState(0);
      const [showUpdateSchedule, setShowUpdateSchedule] = useState(false);
      const [getOrderId,setGetOrderId] = useState(null)
      const [deliveredAt,setDeliveredAt] = useState(null);
      const [deliveredAtModal,setDeliveredAtModal] = useState(false);
      const [listUpdateHistories,setListUpdateHistories] = useState({total:0,list:[]})
      const [dialogLoading,setDialogLoading] = useState(false)
      const [hisPage, setHisPage] = useState(0);
      const [hisLimit, setHisLimit] = useState(5);
      const [driverType, setDriverType] = useState("")
      const HandleOpenUpdateSlot = async (status,order) => {
        setSlotHistoryModal(status);
        setDialogLoading(true);
        setGetOrderId(order.order_id)
        if(status === true){
          await getUpdateHistories(order.order_id)
        }
      };

      const HandleCloseUpdateSlot = async (status=false) => {
        setSlotHistoryModal(status);
        setHisPage(0);
        setHisLimit(5)
        setListUpdateHistories({total:0,list:[]})
      };
      const getUpdateHistories = async (order_id,page=hisPage,limit=hisLimit) => {
        let body = {
          order_id: order_id,
          page:page+1,
          limit:limit
        };
        await API.getUpdateSlotAndDeliveryAt(body)
        .then((res) => res.json())
        .then((res) => {
          if (res.success) {
            setDialogLoading(false)
            setListUpdateHistories(res.data)
          } else {
            setDialogLoading(false)
            alert(res.message);
          }
        });
      }
        // change [normal] table page && limit
  const handleChangePage = (event, newPage) => {
    setHisPage(newPage);
    getUpdateHistories(getOrderId,newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setHisPage(0);
    setHisLimit(Number(event.target.value));
    getUpdateHistories(getOrderId,0,Number(event.target.value));
  };
        // get modified class for modified column
      function getModifiedColClass(obj, key) {
        if (typeof obj !== "object") return;
        return Object.keys(obj).find((objKey) => objKey === key) && "modified";
      }

		const handleShowUpdateSchedule = (order, orderId, deliveredAt, slot_id = 0) => {
        setShowUpdateSchedule(true);
        setGetOrderId(orderId)
        setDeliveredAt(deliveredAt)
        setSelectedSlot(slot_id)
			setSelectedOrder(order)
      }
  
      const handleCloseDeliverySlotModal = (status = false) => {
        setShowUpdateSchedule(status);
        setGetOrderId(null)
        setSelectedSlot(0)
	      setSelectedOrder({})
      }

      const handleChangeDeliveredAt = (e) => {
        setDeliveredAt(moment(e.target.value).format('YYYY-MM-DD HH:mm:ss'))
      }
		const onUpdateSlotSelected = async (slotId, slot) => {
			setSelectedUpdateSlot(slotId);
			setUpdatingSlot(true)
        let body = {
          order_id: getOrderId,
	        slot_id: slotId,
	        slot_type: slot.type,
	        slot_range: slot.slot_range,
          delivered_at:deliveredAt,
        };
			await API.updateSlotAndDeliveryAtByAdmin(body)
          .then((res) => res.json())
          .then((res) => {
            if (res.success) {
              handleCloseDeliverySlotModal();
              handleCloseUpdateDeliveredAt();
	            setUpdatingSlot(false)
              let timeout = setTimeout(() => {
                resetPagination();
                getOrderList(0);
              }, 1000);
              return () => clearTimeout(timeout);
            } else {
	            setUpdatingSlot(false)
              alert(res.message);
            }
          });
      };
      const handleOpenUpdateDeliveredAt = (orderId,deliveredAt,slot_id) => {
        setDeliveredAtModal(status);
        setGetOrderId(orderId)
        setDeliveredAt(deliveredAt)
        setSelectedSlot(slot_id)
      }

      const handleCloseUpdateDeliveredAt = (status=false) => {
        setDeliveredAtModal(status);
        setGetOrderId(null)
        setDeliveredAt(null)
        setSelectedSlot(0)
      }

      const onUpdateDeliveredAt = () => {
        let body = {
          order_id: getOrderId,
          delivered_at:deliveredAt,
        };
        API.updateSlotAndDeliveryAtByAdmin(body)
          .then((res) => res.json())
          .then((res) => {
            if (res.success) {
              handleCloseUpdateDeliveredAt();
              let timeout = setTimeout(() => {
                resetPagination();
                getOrderList(0);
              }, 1000);
              return () => clearTimeout(timeout);
            } else {
              alert(res.message);
            }
          });
      };

      // end
  
      //_________ Class Method for print detail of orders _________

      const toXlsx = (object) => {
        const data = [
          {
            sheet: "Order",
            columns: [
              {label: "Order ID", value: "order_id"},              
              {label: "First Name", value: "first_name"},
              {label: "Last Name", value: "last_name"},              
              {label: "Mobile Number", value: "mobile_number"},
              {label: "House Number", value: "house_number"},
              {label: "Apartment Name", value: "apartment_name"},
              {label: "Street Details", value: "street_details"},
              {label: "Area Details", value: "area_details"},
              {label: "City", value: "city"},
              {label: "Delivery Instructions", value: 'delivery_instructions'},
              {label: "Comments", value: "comments"},
              {label: "Placed At", value: "placedAt"},
              {label: "Start Time", value: "start_time"},
              {label: "End Time", value: "end_time"},             
              {label: "Driver ID", value: "driver_id"},
              {label: "FirstName", value: "driver_firstname"},
              {label: "LastName", value: "driver_lastname"},
              {label: "Coupon Code ID", value: "coupon_code_id"},
              {label: "Coupon Discount", value: "coupon_discount_amount"},
              {label: "Wallet Discount", value: "wallet_discount_amount"},
              {label: "User Promos", value: "user_promos"},
              {label: "Item Total", value: "item_total", format: "$0.00"},
              {label: "Delivery Fee", value: "delivery_fee", format: "$0.00"},
	            {label: "Total", value: "amount", format: "$0.00"},
              {label: "Platform", value: "platform"},
              {label: "Payment Method", value: "payment_method_name"},
            ],
            content: JSON.parse(JSON.stringify(object))
          }
        ]
        const settings = {
          fileName: "Order Report",
          extraLength: 3,
          writeMode: 'writeFile',
          writeOptions: {},
          RTL: false,
        }
        xlsx(data, settings)
      }

      const productToXlsx = (object) => {
        const data = [
          {
            sheet: "Product Order Tracking",
            columns: [
              {label: "Item ID", value: "item_id"},              
              {label: "Name", value: "name"},
              {label: "SKU", value: "product_code"},  
              {label: "Status", value: "status"},            
              {label: "Order Quantity", value: "order_quantity"}
            ],
            content: JSON.parse(JSON.stringify(object))
          }
        ]
        const settings = {
          fileName: "Product Order Tracking",
          extraLength: 3,
          writeMode: 'writeFile',
          writeOptions: {},
          RTL: false,
        }
        xlsx(data, settings)
      }

      const extractOrder = (param) => {
        setIsRequesting(true);
        let tmpStatus = _.clone(status);
        let tmpNumber = tmpStatus
            .toString()
            .split("")
            .map((x) => parseInt(x));
        let statusList = tmpNumber;

        let query = {
          statusList: JSON.stringify(statusList),
          search: textSearch,
          startDate,
          endDate,
          startDateDefault,
          endDateDefault,
          orderField,
          orderType
        };

        //get total day
        let totalDays = -1
        if(endDate != '' && startDate != ''){
          let differance = new Date(endDate) - new Date(startDate)
          totalDays = Math.ceil(differance / (1000 * 3600 * 24));
        }

        if(endDateDefault != "" & startDateDefault != ""){
          let differance = new Date(endDateDefault) - new Date(startDateDefault)
          totalDays = Math.ceil(differance / (1000 * 3600 * 24));
        }

        if(totalDays >= 0 && totalDays <= 184){
          setIsOpenModalExtractReport(false);
          API.getOrderListWithoutPagination(query)
          .then((response) => response.json())
          .then((response) => {
            setIsRequesting(false);
            if (response.success) {
              const ordersList = response.data.list
              let newOrdersList = [];
              ordersList.forEach((order) => {

                if(order.driver === null){
                  order.driver = {first_name: "N/A", id: "N/A", last_name: "N/A"}
                }
                if(order.store_on_going_slot === null){
                  order.store_on_going_slot = {start_time: "N/A", end_time: "N/A"}
                }
                newOrdersList.push({
                  order_id: order.order_id,
                  first_name: order.list_customer_address.first_name,
                  last_name: order.list_customer_address.last_name,
                  mobile_number: order.list_customer_address.mobile_number,
                  house_number: order.list_customer_address.house_number,
                  apartment_name: order.list_customer_address.apartment_name,
                  street_details: order.list_customer_address.street_details,
                  area_details: order.list_customer_address.area_details,
                  city: order.list_customer_address.city,
                  delivery_instructions: order.list_customer_address.delivery_instructions,
                  comments: order.comments,
                  placedAt: order.placedAt,
                  start_time: order.store_on_going_slot.start_time,
                  end_time: order.store_on_going_slot.end_time,
                  driver_id: order.driver.id,
                  driver_firstname: order.driver.first_name,
                  driver_lastname: order.driver.last_name,
	                coupon_code_id: order.coupon_code_id,
	                coupon_discount_amount: order.coupon_discount_amount,
	                wallet_discount_amount: order.wallet_payment,
                  user_promos: order.customer_detail.user_promos,
	                item_total: order.item_total,
	                delivery_fee: order.delivery_fee,
	                amount: order.order_payment_detail.amount,
                  Platform: order.Platform,
	                payment_method_name: order.payment_method_name,

                })
              })
              newOrdersList = JSON.parse(JSON.stringify(newOrdersList))
              console.log(newOrdersList)
              toXlsx(newOrdersList)
            }
          });          
        }
        else{
          setIsRequesting(false);
          alert('only available in 6 months range')
        }

      };

      const extractProductNeverOrder = (param) => {
        setIsProductRequest(true)
        setIsOpenModalExtractReport(false);
        API.getProductNeverOrderWithoutPagination()
        .then((response) => response.json())
        .then((response) => {
          setIsProductRequest(false)
          if (response.success) {
            const ProductList = response.data.list
            let newProductList = [];
            ProductList.forEach((pro) => {
              newProductList.push({
                item_id: pro.item_id,
                name: pro.name,
                product_code: pro.product_code,
                order_quantity: pro.order_item_details.length > 0 ? pro.order_item_details[0]?.order_quantity : pro.order_item_details.length,
                status: pro.is_deleted == 0 ? "Active" : "Inactive"
              })
            })
            newProductList = JSON.parse(JSON.stringify(newProductList))
            productToXlsx(newProductList)
          }
        });

      };
      // ------------------ Methods ------------------
      const getOrderList = (param) => {
        setIsRequesting(true);
        let tmpStatus = _.clone(status);
        let tmpNumber = tmpStatus === -1 ? [tmpStatus] : tmpStatus
            .toString()
            .split("")
            .map((x) => parseInt(x));
        let statusList = tmpNumber;

        let query = {
          statusList: JSON.stringify(statusList),
          search: textSearch,
          startDate,
          endDate,
          orderField,
          orderType
        };

        if (selectedBasketType === "0" || selectedBasketType === "1") {
          query.type = selectedBasketType;
        }

        if ([45, 6, 7, -1, 2345678].includes(status)) {
          query.next = param.toString();
          query.limit = limit.toString();

          API.getOrderListPagination(query)
              .then((response) => response.json())
              .then((response) => {
                setIsRequesting(false);

                if (response.success) {
                  getOrderStatusCount();

                  setTotalNumberList(response.data.total);
                  setOrderList(response.data.list);

                  if (response.data.next) {
                    setNext(response.data.next);
                  } else if (response.data.list.length) {
                    setNext(Number(param) > 0 ? next + response.data.list.length : response.data.list.length);
                  } else {
                    setNext(0);
                  }
                }
              });
        } else {
          API.getOrderListWithoutPagination(query)
              .then((response) => response.json())
              .then((response) => {
                setIsRequesting(false);
                if (response.success) {
                  getOrderStatusCount();

                  if (status === 3) {
                    const tmpOrderList = response.data.list.filter(
                        (x) => !x.driver_id
                    );
                    setOrderList(tmpOrderList);
                  } else {
                    setOrderList(response.data.list);
                  }
                }
              });
        }
      };

      const getOrderListHasDriver = (params) => {
        setIsRequesting(true);
        let statusList = [status];

        let query = {
          statusList: JSON.stringify(statusList),
          search: textSearch,
          startDate,
          endDate,
          orderField,
          orderType
        };

        if (selectedBasketType === "0" || selectedBasketType === "1") {
          query.type = selectedBasketType;
        }

        API.getOrderListWithoutPagination(query)
            .then((response) => response.json())
            .then((response) => {
              setIsRequesting(false);

              if (response.success) {
                getOrderStatusCount();

                const tmpOrderList = response.data.list.filter((x) => x.driver_id);
                setOrderList(tmpOrderList);
              }
            });
      };

      const getDriverList = async () => {
        await API.getDriverList({next: 0, limit: 10000, showType: false})
            .then((response) => response.json())
            .then((response) => {
              if (response.success) {
                setDriverList(response.data.list);
                setIsOpenModalAddDriver(true);
              }
            });
      };

      const getOrderStatusCount = () => {
        setIsRequesting(true);

        API.getOrderStatusCount()
            .then((response) => response.json())
            .then((response) => {
              setIsRequesting(false);
              if (response.success) {
                setOrderStatusCount(response.data);
              }
            });
      };

      const getOrderPayment = (order) => {
        return order && order.order_payment_detail
            ? order.order_payment_detail
            : order.order_payment_details[0];
      };

      const getOnGoingSlot = (order) => {
        if (order && order.store_on_going_slot) {
          return order.store_on_going_slot;
        } else if (
            order &&
            order.store_on_going_slot &&
            order.store_on_going_slot.length
        ) {
          return order.store_on_going_slots[0];
        } else {
          return "";
        }
      };

      const getFormatDateForDisplay = (date) => {
        return moment(date).format("DD/MM/YYYY - h:mm a");
      };

      const getFormatCurrencyForDisplay = (number) => {
        return new Intl.NumberFormat("en-IN", {
          style: "currency",
          currency: "USD",
        }).format(number);
      };

      const getWalletTransactionByCustomerId = (order) => {
        try {
          setIsWalletRequesting(true);
          API.getWalletTransactionByCustomerId({
            customerId: order.cust_id,
            next: 0,
            limit: 10,
          })
              .then((res) => res.json())
              .then((res) => {
                setIsWalletRequesting(false);
                if (res.success) {
                  setWalletTransactionList(res.data.list);
                }
              });
        } catch (e) {
          console.log("Error, can not find wallet transaction", e);
          setWalletTransactionList([]);
          setIsShowWalletTransactionModal(false);
        }
      };

      const resetWalletFormData = () => {
        setWalletAmount(0);
        setComment("");
        setReason("refund");
        setTransactionType("credit");
      };

      const resetWalletFormError = () => {
        setWalletFormError({
          walletAmount: false,
          comment: false,
          transactionType: false,
          reason: false,
        });
      };

      const resetDateFilter = () => {
        setStartDateFilter(null);
        setEndDateFilter(null);
        if (startDateFilterRef && startDateFilterRef.current) {
          startDateFilterRef.current.state.inputValue = "";
        }
        if (endDateFilterRef && endDateFilterRef.current) {
          endDateFilterRef.current.state.inputValue = "";
        }

        // reset query params
        setStartDate("");
        setEndDate("");
      }

      const resetPagination = () => {
        setPager(1);
        setPrev(0);
      }

      const getOrderStatusCountByLabel = (label) => {
        if (!_.isEmpty(orderStatusCount)) {
          if (label === "New") {
            return orderStatusCount.pending ? `(${orderStatusCount.pending})` : "";
          } else if (label === "Accepted") {
            return orderStatusCount.processingNoDriver
                ? `(${orderStatusCount.processingNoDriver})`
                : "";
          } else if (label === "Assigned to driver") {
            return orderStatusCount.processingDriver
                ? `(${orderStatusCount.processingDriver})`
                : "";
          } else if (label === "Packed & On the way") {
            return orderStatusCount.pickUp || orderStatusCount.delivering
                ? `(${orderStatusCount.pickUp + orderStatusCount.delivering})`
                : "";
          } else if (label === "Arrived") {
            return orderStatusCount.arrived ? `(${orderStatusCount.arrived})` : "";
          } else if (label === "Cancelled") {
            return orderStatusCount.cancel ? `(${orderStatusCount.cancel})` : "";
          } else if (label === "Delivered") {
            return orderStatusCount.delivered ? `(${orderStatusCount.delivered})` : "";
          } else if(label === "Waiting Payment"){
            return orderStatusCount.waitingPayment ? `(${orderStatusCount.waitingPayment})` : "";
          } else {
            return orderStatusCount.all ? `(${orderStatusCount.all})` : "";
          }
        }
      };

      // ----------------- Compute data ----------------
      useEffect(() => {
        if (status === 3 && isShowOnlyAcceptedHasDriver) {
          getOrderListHasDriver(0);
        } else {
          getOrderList(0);
        }

        if (status === 3 && !isShowOnlyAcceptedHasDriver) {
          setIsAllowAddDriver(true);
        } else {
          setIsAllowAddDriver(false);
        }
      }, [status, isShowOnlyAcceptedHasDriver, selectedBasketType, textSearch, startDate, endDate, orderField, orderType]);

//   useEffect(() => {
//     if (status === 3 && isShowOnlyAcceptedHasDriver) {
//       getOrderListHasDriver(0);
//     } else {
//       getOrderList(0);
//     }
//   }, [selectedBasketType]);

      // ---------------- Event change -----------------
      const handleSelectOrderStatus = (e) => {
        // reset date filter
        resetDateFilter();

        // reset pagination
        resetPagination();

        let data = orderStatusOpts[e.target.value].value;
        setSelectedStatus(e.target.value);
        handleGetOrderByStatus(data);
      };

      const handleOrderTypeChange = (e) => {
        // reset date filter
        resetDateFilter();

        // reset pagination
        resetPagination();

        setSelectedBasketType(e.target.value);
      };

      const handleGetOrderByStatus = ({status, isShowAccptedHasDriver}) => {
        setIsShowOnlyAcceptedHasDriver(isShowAccptedHasDriver);
        if (status === 2345678) {
          setAccept(true);
          setDispatch(true);
          setIsAllowAddDriver(true);
          setQuery(false);
          setSelectedStatus(0);
        }
        else if (status === 2) {
          setAccept(true);
          setDispatch(false);
          setIsAllowAddDriver(false);
          setQuery(false);
          setSelectedStatus(1);
        }
        else if (status === -1) {
          setSelectedStatus(8);
          setAccept(false);
          setQuery(true);
        } else {
          setQuery(false);
          if (status === 4 || status === 3) {
            setAccept(false);
            setDispatch(true);
            if (status === 3 && isShowAccptedHasDriver) {
              setSelectedStatus(3);
            } else {
              setSelectedStatus(2);
            }
          } else {
            setAccept(false);
            setDispatch(false);

            if (status === 8) {
              setSelectedStatus(6);
            } else if (status === 6) {
              setSelectedStatus(5)
            }
            else if (status === 7) {
              setSelectedStatus(7);
            } else if (status === 45) {
              setSelectedStatus(4);
            }
          }
        }
        setOrderIDs([]);
        setStatus(status);
      };

      const bulkSelection = (value) => {
        let tmp = [...orderIDs];
        if (tmp.filter((id) => id == value).length > 0) {
          setOrderIDs(tmp.filter((id) => id != value));
          if (tmp.filter((id) => id != value).length < 1) setIsSelected(false);
        } else {
          tmp.push(value);
          setOrderIDs(tmp);
          setIsSelected(true);
        }
      };

      const bulkSelectionAll = () => {
        if(orderList && orderList.length){
          if(orderIDs.length){
            const isSelectedAll = orderList.every(x => orderIDs.includes(x.order_id));
            const isSelectedSome = orderList.some(x => orderIDs.includes(x.order_id));

            if(isSelectedAll || isSelectedSome){
              const orderListId = orderList.map(x => x.order_id);
              const selectedAllOrderId = orderIDs.filter(x => !orderListId.includes(x));
              setOrderIDs(selectedAllOrderId);
              if(!selectedAllOrderId.length){
                setIsSelected(false)
              }
            }else {
              const selectedAllOrderId = orderList.map(x => x.order_id);
              setOrderIDs(prevState => ([...prevState, ...selectedAllOrderId]));
              setIsSelected(true);
            }
          }else{
            const selectedAllOrderId = orderList.map(x => x.order_id);
            setOrderIDs(prevState => ([...prevState, ...selectedAllOrderId]));
            setIsSelected(true);
          }
        }
      }

      const handleChangeStatus = (id, statu) => {
        handleCloseConfirmModal();

        API.changeOrderStatus({
          order_id: id,
          order_status: statu,
          store_id: 1,
        }).then(() => {
          if (status === 3 && isShowOnlyAcceptedHasDriver) {
            getOrderListHasDriver(0);
          } else {
            resetPagination();
            getOrderList(0);
          }
        });
      };

      const handleGenerateInvoice = (orderId) => {
        setIsRequestingSendFile(true);
        API.generateInvoice({
          order_id: orderId,
        }).then(() => {
          alert("Generating Invoice and Sending");
          setIsRequestingSendFile(false);
          handleCloseModalConfirmSendFile()
        });
      };

      const handleSortOrder = (field) => {
        // reset pagination
        resetPagination();

        if (field === orderField) {
          setOrderType(orderTypeOpts.find(x => x !== orderType));
        } else {
          setOrderType("ASC");
          setOrderField(field);
        }
      };

      const handleAmountSort = () => {
        if (orderList.length) {
          orderList.sort(function (a, b) {
            const aHas =
                a && a.order_payment_detail
	                ? typeof a.order_payment_detail.amount !== "undefined"
                    : false;
            const bHas =
                b && b.order_payment_detail
	                ? typeof b.order_payment_detail.amount !== "undefined"
                    : false;
            if (sortFlag)
              return aHas && bHas
	              ? b.order_payment_detail.amount - a.order_payment_detail.amount
                  : 0;
            else
              return aHas && bHas
	              ? a.order_payment_detail.amount - b.order_payment_detail.amount
                  : 0;
          });
          setOrderArrow(false);
          setAmountArrow(true);
          setDateArrow(false);
          setSortFlag(!sortFlag);
        }
      };

      const handleDateSort = () => {
        if (orderList.length) {
          orderList.sort(function (a, b) {
            const aHas =
                a && a.store_on_going_slot
                    ? typeof a.store_on_going_slot.start_time !== "undefined"
                    : false;
            const bHas =
                b && b.store_on_going_slot
                    ? typeof b.store_on_going_slot.start_time !== "undefined"
                    : false;
            if (sortFlag) {
              return bHas && aHas
                  ? new Date(b.store_on_going_slot.start_time) -
                  new Date(a.store_on_going_slot.start_time)
                  : 0;
            } else {
              return aHas && bHas
                  ? new Date(a.store_on_going_slot.start_time) -
                  new Date(b.store_on_going_slot.start_time)
                  : 0;
            }
          });
          setOrderArrow(false);
          setAmountArrow(false);
          setDateArrow(true);
          setSortFlag(!sortFlag);
        }
      };

      const handleBulkSubmit = (statu) => {
        if(statu === 7) {
          handleCloseConfirmModalOrdersSelect()
        }
        let idStr = "" + orderIDs[0];
        for (let i = 1; i < orderIDs.length; ++i) idStr = idStr + "|" + orderIDs[i];

        API.changeBulkOrderStatus({
          order_ids: idStr,
          order_status: statu,
        }).then(() => {
          setIsSelected(false);
          setOrderIDs([]);

          if (status === 3 && isShowOnlyAcceptedHasDriver) {
            getOrderListHasDriver(0);
          } else {
            resetPagination();
            getOrderList(0);
          }
        });
      };

      const handlePickup = () => {
        setIsRequestingSendPickupFile(true);
        let idStr = "" + orderIDs[0];
        for (let i = 1; i < orderIDs.length; ++i) idStr = idStr + "|" + orderIDs[i];

        API.createPickupFile({
          order_ids: idStr,
        }).then(() => {
          alert("Generating pickup file and Sending");
          setIsRequestingSendPickupFile(false);
          window.location.reload();
        });
      };

      const handleBulkGenerateInvoice = () => {
        setIsRequestingSendMultiInvoiceFile(true);
        let idStr = "" + orderIDs[0];
        for (let i = 1; i < orderIDs.length; ++i) idStr = idStr + "|" + orderIDs[i];

        API.generateBulkInvoice({
          order_ids: idStr,
        }).then(() => {
          alert("Generating Invoice and Sending");
          setIsRequestingSendMultiInvoiceFile(false);
          window.location.reload();
        });
      };

      const handlePaginNext = () => {
        const {next, prev} = updatePaginationProps("NEXT");

        getOrderList(prev);
      };

      const handlePaginPrev = () => {
        const {pager, next, prev} = updatePaginationProps("PREV");

        getOrderList(prev);
      };

      const updatePaginationProps = (type) => {
        let tmpPager = pager + 1;
        if (type === "PREV") {
          tmpPager = pager - 1;
        }

        const tmpNext = limit * tmpPager;
        const tmpPrev = limit * tmpPager - limit;

        setPager(tmpPager);
        setPrev(tmpPrev);

        return {pager: tmpPager, next: tmpNext, prev: tmpPrev};
      };

      const handleOpenModalAddDriver = (order,type="") => {
        setOrderUpdate(order);
        getDriverList();
        if(type != ""){
          setDriverType(type)
        }
      };

      const handleOpenModalEditDriver = (order,type="") => {
        setOrderUpdate(order);
        getDriverList();
        if(type == "secondary"){
          setDriverType(type)
          setSelectedDriver(order.secondary_driver);
        }else{
          setSelectedDriver(order.driver_id);
        }
      };
      

      const handleCloseModalAddDriver = () => {
        setIsOpenModalAddDriver(false);
        setSelectedDriver("");
        setDriverList([]);
        setDriverType("");
      };

      const handleSubmit = () => {
        setIsRequestingUpsert(true);
        setIsOpenModalAddDriver(false);
        const params = {
          orderId: orderUpdate.order_id,
        };

        const body = {
          driver_id: selectedDriver,
        };

        if(driverType == "secondary"){
          API.addSecondaryDriver(params, body)
              .then((response) => response.json())
              .then((response) => {
                setIsRequestingUpsert(false);
                if (response.success) {
                  if (status === 3 && isShowOnlyAcceptedHasDriver) {
                    getOrderListHasDriver(0);
                  } else {
                    resetPagination();
                    getOrderList(0);
                  }
  
                  setOrderUpdate({});
                  setSelectedDriver("");
                  setDriverList([]);
                  handleShowToast("SUCCESS");
                  setDriverType("");
                } else {
                  handleShowToast("ERROR");
                }
              });
        }else{
          API.updateOrder(params, body)
              .then((response) => response.json())
              .then((response) => {
                setIsRequestingUpsert(false);
                if (response.success) {
                  if (status === 3 && isShowOnlyAcceptedHasDriver) {
                    getOrderListHasDriver(0);
                  } else {
                    resetPagination();
                    getOrderList(0);
                  }

                  setOrderUpdate({});
                  setSelectedDriver("");
                  setDriverList([]);
                  handleShowToast("SUCCESS");
                } else {
                  handleShowToast("ERROR");
                }
              });
          }
      };

      const handleRemoveSecondaryDriver = () => {
        setIsRequestingUpsert(true);
        setIsOpenModalAddDriver(false);
        const params = {
          orderId: orderUpdate.order_id,
        };

        const body = {
          driver_id: selectedDriver,
        };
          API.removeSecondaryDriver(params, body)
              .then((response) => response.json())
              .then((response) => {
                setIsRequestingUpsert(false);
                if (response.success) {
                  if (status === 3 && isShowOnlyAcceptedHasDriver) {
                    getOrderListHasDriver(0);
                  } else {
                    resetPagination();
                    getOrderList(0);
                  }
  
                  setOrderUpdate({});
                  setSelectedDriver("");
                  setDriverList([]);
                  handleShowToast("SUCCESS");
                  setDriverType("");
                } else {
                  handleShowToast("ERROR");
                }
              });
      };
      const handleSelectDriver = (driverId) => {
        setSelectedDriver(driverId);
      };

      const handleOpenConfirmModal = (orderId) => {
        setIsShowConfirmModal(true);
        setOrderIdToCancel(orderId);
      };

      const handleCloseConfirmModal = () => {
        setIsShowConfirmModal(false);
        setOrderIdToCancel("");
      };

      const handleOpenConfirmModalOrdersSelect = () => {
        setIsShowConfirmModalOrder(true);
      };

      const handleCloseConfirmModalOrdersSelect = () => {
        setIsShowConfirmModalOrder(false);
      };

      const handleOpenAddWalletTransactionModal = (order) => {
        setOrderToAddWallet(order);
        setIsShowAddWalletTranModal(true);
      };

      const handleCloseAddWalletTransactionModal = () => {
        setIsShowAddWalletTranModal(false);
        resetWalletFormData();
        resetWalletFormError();
        setOrderToAddWallet({});
      };

      const handleSummitAddWallet = () => {
        setIsWalletRequesting(true);

        if (walletAmount > 0) {
          const body = {
            transaction_type: transactionType,
            wallet_owner_id: orderToAddWallet.cust_id,
            reason,
            wallet_amount: Number(walletAmount),
            comment,
            order_number: orderToAddWallet.order_id,
          };

          API.addWalletTransaction(body)
              .then((response) => response.json())
              .then((response) => {
                setIsWalletRequesting(false);

                if (response.success) {
                  handleCloseAddWalletTransactionModal();
                  handleShowToast("SUCCESS");
                } else {
                  handleShowToast("ERROR");
                }
              });
        } else {
          if (!walletAmount || !(walletAmount > 0)) {
            setWalletFormError((prevState) => ({
              ...prevState,
              walletAmount: true,
            }));
          }

          setIsWalletRequesting(false);
        }
      };

      const handleViewWalletTransaction = (order) => {
        setOrderToViewWallet(order);
        handleOpenWalletTransactionModal();
        getWalletTransactionByCustomerId(order);
      };

      const handleOpenWalletTransactionModal = () => {
        setIsShowWalletTransactionModal(true);
      };

      const handleCloseWalletTransactionModal = () => {
        setWalletTransactionList([]);
        setOrderToViewWallet({});
        setIsShowWalletTransactionModal(false);
      };

      // Filters event handler
      const handleChangeStartDate = ((event) => {
        let tmpEvent = moment(event).format('YYYY-MM-DD');
        setStartDateFilter(tmpEvent);
        setStartDate(tmpEvent);

        if (endDateFilter) {
          if (
              moment(endDateFilter, "YYYY/MM/DD").isBefore(moment(tmpEvent, "YYYY/MM/DD"))
          ) {
            setEndDateFilter("");
            endDateFilterRef.current.state.inputValue = "";
          }
        }
        // reset query params
        setStartDateDefault("");
        setEndDateDefault("");
      });

      const handleChangeEndDate = ((event) => {
        let tmpEvent = moment(event).format('YYYY-MM-DD');
        setEndDateFilter(tmpEvent);
        endDateFilterRef.current.state.inputValue = tmpEvent;
        setEndDate(tmpEvent);
        if (startDateFilter) {
          if (
              moment(tmpEvent, "YYYY/MM/DD").isBefore(moment(startDateFilter, "YYYY/MM/DD"))
          ) {
            setStartDateFilter("");
            startDateFilterRef.current.state.inputValue = "";
          }
        }
        // reset query params
        setStartDateDefault("");
        setEndDateDefault("");
      });

      const handleFilter = () => {
        // reset pagination
        resetPagination();

        let cloneStartDateFilter = _.clone(startDateFilter);
        let cloneEndDateFilter = _.clone(endDateFilter);
        setStartDate(cloneStartDateFilter);
        setEndDate(cloneEndDateFilter);
      }

      const handleClearFilter = () => {
        // reset pagination
        resetPagination();

        // reset filter
        resetDateFilter();
        setSelectedBasketType('');
        setTextSearch('');
        setSelectedStatus(0);
        handleGetOrderByStatus(orderStatusOpts[0].value);
      }

      // toast event
      const handleShowToast = (type) => {
        setShowToast(true);

        if (type === "SUCCESS") {
          setToastBgColor("bg-success");
          setToastMessage("Operation successful.");
        } else if (type === "ERROR") {
          setToastBgColor("bg-danger");
          setToastMessage("Operation error.");
        }
      }

      // modal confirm send file
      const handleOpenModalConfirmSendFile = (orderId) => {
        setIsOpenModalConfirmSendFile(true);
        setOrderIdToSendFile(orderId)
      }

      const handleCloseModalConfirmSendFile = () => {
        setIsOpenModalConfirmSendFile(false);
        setOrderIdToSendFile("");
      }

      // set time before call api
      let typingTimer; //timer identifier
      let doneTypingInterval = 1000; //time in ms (7.5 seconds)
      const handleSearch = (value) => {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(function () {
          // reset date filter
          resetDateFilter();

          // reset pagination
          resetPagination();

          setTextSearch(value);
        }, doneTypingInterval);
      };

      //Print detail of orders 
      const handlePrintDital = () => {
          setIsOpenModalExtractReport(true);
      }

      const handleChangeReport = (event) => {
        setValue(event.target.value);
      }
      
      const handleSubmitExtractReport = (event) => {
        event.preventDefault();
    
        if (value === "0") {
          extractOrder();
        } else if(value === "1") {
          extractProductNeverOrder();
        }
      };
      // query order
      const handleQueryOrder = (order_id) => {
        const loading = queryLoading.slice();
        loading[order_id] = true;
        setQueryLoading(loading);
        setQueryDisable(true);
        API.queryOrder({ order_id })
          .then(res => res.json())
          .then((res) => {
            if (res.success) {
              setQueryData(res.data);
              setQueryOrderId(order_id);
              setModalQueryOpen(true);
            } else {
              alert(res.message);
            }
            loading[order_id] = false;
            setQueryLoading(loading);
            setQueryDisable(false);
          });
      };
      
      const handleApproveOrder = () => {
        API.approveOrder({ order_id: queryOrderId })
          .then(res => res.json())
          .then((res) => {
            if (res.success) {
              setQueryOrderId(null);
              setModalQueryOpen(false);
              resetPagination();
              getOrderList(0);
            } else {
              alert(res.message);
            }
          });
      }

      const handleShowSchedule = (orderId) => {
        setShowSchedule(true);
        setQueryOrderId(orderId)
      }
  
      const handleDeliverySlotCloseModal = (status = false) => {
        setShowSchedule(status);
        setQueryOrderId(null)
      }
      
      const onSlotSelected = (slot_id) => {
        setSelectedSlot(slot_id);
        let body = {
          order_id: queryOrderId,
          slot_id: slot_id,
          _locale: localStorage.getItem("lang") === "en" ?? "km",
        };
        API.updateSlot(body)
          .then((res) => res.json())
          .then((res) => {
            if (res.success) {
              handleDeliverySlotCloseModal();
              let timeout = setTimeout(() => {
                resetPagination();
                getOrderList(0);
              }, 1000);
              return () => clearTimeout(timeout);
            } else {
              alert(res.message);
            }
          });
      };
      
      const handleClickUpdateOutTradeNo = (orderId) => {
        return () => {
          if(!window?.confirm(`You are about to update out trade no of order #${orderId}!`)) return;
          API.updateOutTradeNo(orderId)
            .then((res) => res.json())
            .then((res) => {
              if(res.success){
                handleShowToast("SUCCESS");
                let timeout = setTimeout(() => {
                  resetPagination();
                  getOrderList(0);
                }, 1000);
                return () => clearTimeout(timeout);
              } else {
                console.log(res.message);
                handleShowToast("ERROR");
              }
            })
        }
      }
		const renderSlotCellContent = (order, query, handleShowSchedule) => {
			const ongoingSlot = getOnGoingSlot(order);
			const isHourly = order.slot_type === "hourly";
			const isMedium = order.slot_type === "medium";
			const isLarge = order.slot_type === "large";

			if (!query) {
				if (order.type === 1) {
					return <p className="text-center">ASAP</p>;
				}

				if (!ongoingSlot) return null;

	            return `${moment(ongoingSlot.Date).format("DD/MM/YYYY")} ${moment(ongoingSlot.start_time).format("h:mm a")} - ${moment(ongoingSlot.end_time).format("h:mm a")}`;
            }

			if (order.type === 1) {
				return <p className="text-center">ASAP</p>;
			}

			if (!ongoingSlot) return null;

            return (
                <Button
                    className="w-100 d-flex flex-column"
                    onClick={() => handleShowSchedule(order.order_id)}
                >
                    Update Slot{" "}
                    <small>
                        (
                        {isHourly
                            ? getFormatDateForDisplay(ongoingSlot.start_time)
                            : isMedium
                                ? `${getFormatDateForDisplay(ongoingSlot.start_time)} - ${getFormatDateForDisplay(ongoingSlot.end_time)}`
                                : isLarge
                                    ? `any time at ${moment(ongoingSlot.Date).format("YYYY/MM/DD")}`
                                    : ""}
                        )
                    </small>
                </Button>
            );
        };
        // ---------------- Custom components -----------
      let content = null;
      if (orderList && orderList.length) {
        content = orderList.map((order, index) => (
            <tr key={index}>
              {
                status === 2345678 &&
                <td>
                  {
                    order.status === 2 ?
                        <Button variant="success"
                                className="text-dark"
                                style={{
                                  backgroundColor: "#ED9704",
                                  width: "12vh",
                                  border: "none",
                                  cursor: "auto",
                                  outline: "none",
                                  boxShadow: "none"
                                }}
                        >
                          New
                        </Button> :
                        order.status === 3 ?
                            <Button variant="success"
                                    className="text-dark"
                                    style={{
                                      backgroundColor: "#F30A0B",
                                      width: "12vh",
                                      border: "none",
                                      cursor: "auto",
                                      outline: "none",
                                      boxShadow: "none"
                                    }}
                            >
                              Accepted
                            </Button> :
                            order.status === 4 ?
                                <Button variant="success"
                                        className="text-dark"
                                        style={{
                                          backgroundColor: "#4D4C5C",
                                          width: "12vh",
                                          border: "none",
                                          cursor: "auto",
                                          outline: "none",
                                          boxShadow: "none"
                                        }}
                                >
                                  Packed
                                </Button> :
                                order.status === 5 ?
                                    <Button variant="success"
                                            className="text-dark"
                                            style={{
                                              backgroundColor: "#56E76F",
                                              width: "12vh",
                                              border: "none",
                                              cursor: "auto",
                                              outline: "none",
                                              boxShadow: "none"
                                            }}
                                    >
                                      On the way
                                    </Button> :
                                    order.status === 6 ?
                                        <Button variant="success"
                                                className="text-dark"
                                                style={{
                                                  backgroundColor: "#49A641",
                                                  width: "12vh",
                                                  border: "none",
                                                  cursor: "auto",
                                                  outline: "none",
                                                  boxShadow: "none"
                                                }}
                                        >
                                          Delivered
                                        </Button> :
                                        order.status === 7 ?
                                            <Button variant="success"
                                                    className="text-dark"
                                                    style={{
                                                      backgroundColor: "#A10559",
                                                      width: "12vh",
                                                      border: "none",
                                                      cursor: "auto",
                                                      outline: "none",
                                                      boxShadow: "none"
                                                    }}
                                            >
                                              Cancelled
                                            </Button> :
                                            order.status === 8 ?
                                                <Button variant="success"
                                                        className="text-dark"
                                                        style={{
                                                          backgroundColor: "#7E481C",
                                                          width: "12vh",
                                                          border: "none",
                                                          cursor: "auto",
                                                          outline: "none",
                                                          boxShadow: "none"
                                                        }}
                                                >
                                                  Arrived
                                                </Button> : null


                  }
                </td>
              }
              {
                query ? null : 
                <td>
                  <Checkbox
                      checked={orderIDs.includes(order.order_id)}
                      key={order.order_id}
                      onChange={() => bulkSelection(order.order_id)}
                      color="primary"
                      inputProps={{ 'aria-label': 'secondary checkbox' }}
                  />

                  {/*<CheckBox*/}
                      {/*key={order.order_id}*/}
                      {/*id={order.order_id}*/}
                      {/*bulkSelection={bulkSelection}*/}
                  {/*/>*/}
              </td>
              }
              <td>
                {order.type === 1 ?
                    <img src={require("../../assets/delixpress_logo.svg")} width="40px"/> :
                    <img src={require("../../assets/delishop_logo.svg")} width="40px"/>
                }

              </td>
              <td>
              {
                order.type === 1 ?
                  <Link
                    target="_blank"
                    to={{pathname: "/admin/order/details/" + order.order_id}}
                  >
                    {order.order_id}  
                  </Link> :
                  getOnGoingSlot(order).start_time ?
                    <Link
                      className="disabled"
                      target="_blank"
                      to={{pathname: "/admin/order/details/" + order.order_id}}
                    >
                      {order.order_id}
                    </Link> : <p className="text-muted">{order.order_id}</p>
                }
              </td>
	            <td>
		            <Link
			            to={{
				            pathname: "/admin/customers",
				            search: `?search=${encodeURIComponent(order.customer_detail.name)}`,
			            }}
		            >
			            {order.customer_detail ? order.customer_detail.name : ""}
		            </Link>
	            </td>
              <td className="d-flex justify-content-center">
                <RemoveRedEye style={{cursor: "pointer"}} className="text-primary"
                              onClick={() => handleViewWalletTransaction(order)}></RemoveRedEye>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Edit style={{cursor: "pointer"}} className="text-success"
                      onClick={() => handleOpenAddWalletTransactionModal(order)}></Edit>
              </td>
              {/*{status === 45 && (*/}
              {/*<td>*/}
              {/*<span>{order.status === 4 ? "PickedUp" : "Delivering"}</span>*/}
              {/*</td>*/}
              {/*)}*/}
              {/*<td>{getFormatDateForDisplay(order.placedAt)}</td>*/}
              <td className="text-right">
	              {getFormatCurrencyForDisplay(order.order_total)}
              </td>
	            <td className="text-right" style={{
		            color: (Math.abs(order.remaining_amount || 0) < 0.01 ? '#2e7d32' : '#d32f2f'),
		            fontWeight: 500
	            }}>
		            {order.remaining_amount !== undefined ? getFormatCurrencyForDisplay(order.remaining_amount) : getFormatCurrencyForDisplay(0)}
	            </td>
	            <td>
		            {order.list_customer_address?.city || '-'}
	            </td>
              <td style={{width: "22vh"}}>
	              {order?.payment_method_name == "Paid online (ABA)" &&
                  getOrderPayment(order).p_status
                    ? "Paid online (ABA) Payment failed/Ongoing"
		              : (getOrderPayment(order).amount === 0) ? "Paid by wallet" : order?.payment_method_name}
              </td>
              {status === -1 ? (
                <td>
                
                  {order?.order_payment_detail?.p_txnld ? (
                    <div className="w-100 d-flex align-items-center justify-content-between" style={{ gap: 5 }}>
                      <p className="text-nowrap">{order?.order_payment_detail?.p_txnld}</p>
                      <Tooltip arrow title={`Update out trade no - #${order?.order_id}`}>
                        <IconButton
                          className="text-info"
                          onClick={handleClickUpdateOutTradeNo(order?.order_id)}
                        >
                          <Refresh />
                        </IconButton>
                      </Tooltip>
                    </div>
                  ) : (
                    "-"
                  )}
                </td>
              ) : null}
              <td>{getFormatDateForDisplay(order.placedAt)}</td>
	            <td>
		            {renderSlotCellContent(order, query, handleShowSchedule)}
	            </td>

                {/*<td>{order.type === 1 ? "Express" : "Normal"}</td>*/}
              {status !== 3 && !(accept || dispatch) && !query && (
                  <td>
                            <span>
                              {order && order.driver && order.driver.first_name
                                  ? order.driver.first_name
                                  : ""}{" "}
                              {order && order.driver && order.driver.last_name
                                  ? order.driver.last_name
                                  : ""}
                            </span>
                  </td>
              )}
             {
              status !== 3 && !(accept || dispatch) && !query && (
                <td>
                  {order.secondaryDriver ? 
                 <span
                  className="text-primary"
                  role="button"
                  onClick={() => handleOpenModalEditDriver(order,"secondary")}
                  >
                    {order && order.secondaryDriver && order.secondaryDriver.first_name
                    ? order.secondaryDriver.first_name : ""}{" "}
                    {order && order.secondaryDriver && order.secondaryDriver.last_name
                        ? order.secondaryDriver.last_name
                        : ""
                    }
                  </span> :
                    <Button
                    variant="success"
                    onClick={() => handleOpenModalAddDriver(order, "secondary")}
                  >
                    Assign Secondary Driver
                  </Button>
                  }
                </td>
              )
            }

              {(accept || dispatch) && !query ? (
                  <>
                    {dispatch && (
                        <td>
                          {order.status === 3 && !order.driver ? (
                              <Button
                                  variant="success"
                                  onClick={() => handleOpenModalAddDriver(order)}
                              >
                                Assign
                              </Button>
                          ) : order.driver && order.status === 3 && (status === 3 || status === 2345678) ? (
                              <span
                                  className="text-primary"
                                  role="button"
                                  onClick={() => handleOpenModalEditDriver(order)}
                              >
                                            {order && order.driver && order.driver.first_name
                                                ? order.driver.first_name
                                                : ""}{" "}
                                {order && order.driver && order.driver.last_name
                                    ? order.driver.last_name
                                    : ""
                                }
                                        </span>
                          ) : order.driver && status !== 3 ? (
                              <span>
                    {order && order.driver && order.driver.first_name
                        ? order.driver.first_name
                        : ""}{" "}
                                {order && order.driver && order.driver.last_name
                                    ? order.driver.last_name
                                    : ""}
                  </span>
                          ) : (
                              ""
                          )}
                        </td>
                    )}
                      {(accept || dispatch) && !query && dispatch && (
                        <td>
                        {order.status === 3 && !order.secondaryDriver ? (
                            <Button
                                variant="success"
                                onClick={() => handleOpenModalAddDriver(order,"secondary")}
                            >
                              Assign Secondary Driver
                            </Button>
                        ) : order.secondaryDriver && order.status === 3 && (status === 3 || status === 2345678) ? (
                            <span
                                className="text-primary"
                                role="button"
                                onClick={() => handleOpenModalEditDriver(order,"secondary")}
                            >
                              {order && order.secondaryDriver && order.secondaryDriver.first_name
                              ? order.secondaryDriver.first_name : ""}{" "}
                              {order && order.secondaryDriver && order.secondaryDriver.last_name
                                  ? order.secondaryDriver.last_name
                                  : ""
                              }
                           </span>
                        ) : order.secondaryDriver && status !== 3 && order.status !== 2 ? (
                            <span
                                className="text-primary"
                                role="button"
                                onClick={() => handleOpenModalEditDriver(order,"secondary")}
                            >
                              {order && order.secondaryDriver && order.secondaryDriver.first_name
                                  ? order.secondaryDriver.first_name : ""}{" "}
                                {order && order.secondaryDriver && order.secondaryDriver.last_name
                                    ? order.secondaryDriver.last_name
                                    : ""
                                }
                           </span>
                        ) : (
                            order.status !== 2 && <Button
                            variant="success"
                            onClick={() => handleOpenModalAddDriver(order,"secondary")}
                        >
                            Assign Secondary Driver
                        </Button>
                        )}
                      </td>
                        )}
                  {status !== 3 && !(accept || dispatch) && !query && (
                    <td>
                      <span>
                        {order && order.secondaryDriver && order.secondaryDriver.first_name ? order.secondaryDriver.first_name
                        : ""}{" "} {order && order.secondaryDriver && order.secondaryDriver.last_name ?
                        order.secondaryDriver.last_name : 
                        <Button
                            variant="success"
                            onClick={() => handleOpenModalAddDriver(order,"secondary")}
                        >
                          Assign Secondary Driver
                        </Button>
                        }
                      </span>
                    </td>
                  )}

                    {accept && (
                        <td>
                          {
                            order.status === 2 ?
                                <Button
                                    variant="success"
                                    onClick={() => handleChangeStatus(order.order_id, 3)}
                                >
                                  Accept
                                </Button> :
                                null
                          }

                        </td>
                    )}
                    <td>
                      {
                        order.status === 2 || order.status === 3 ?
                            <Button
                                className="bg-danger"
                                variant="danger"
                                onClick={() => handleOpenConfirmModal(order.order_id)}
                            >
                              Cancel
                            </Button> :
                            null
                      }

                    </td>

                    <td className="text-center">
                      {
                        order.status === 2 || order.status === 3 ?
                            <EmailIcon
                                style={{color: green[500], cursor: "pointer"}}
                                onClick={() => handleOpenModalConfirmSendFile(order.order_id)}
                            /> :
                            null
                      }

                    </td>
                  </>
              ) : (
                  <></>
              )}
              
              {
                query ?
                  <td>
                    <Button
                      className="w-100 bg-warning"
                      variant="warning"
                      disabled={!queryLoading[order.order_id] && queryDisable}
                      onClick={() => handleQueryOrder(order.order_id)}
                    >
                      {
                        queryLoading[order.order_id] ? <Spinner animation="border" variant="light"/> : "Query"
                      }
                    </Button>
                  </td> : <></>
              }
              <Can
                headPermit="Orders" 
                keyPermit="orders_change_time_slot"
              >
                <td>
                  {order.type === 0  ?
                    <div className="d-flex align-items-center">
	                    {(order.status === 2 || order.status === 3) && <Button variant="outline-primary" className="w-100"
	                                                                           onClick={() => handleShowUpdateSchedule(order, order.order_id, order.delivered_at, order.slot_id)}>
                        Update Slot
                      </Button>}
                      {(order.status >= 4 && order.status !== 7) && <Button variant="success" className="w-100 ml-1" onClick={() => handleOpenUpdateDeliveredAt(order.order_id,order.delivered_at,order.slot_id)}>
                        Update Delivered At
                      </Button>}
                      <Tooltip title="View Histories">
                        <HistoryIcon style={{cursor: "pointer"}} className="text-success ml-2" onClick={() => HandleOpenUpdateSlot(true,order)}></HistoryIcon>
                      </Tooltip>
                    </div>
                    :
                      <div className="d-flex align-items-center">

                      {(order.status >= 4 && order.status !== 7) && <Button variant="success" className="w-100 ml-1" onClick={() => handleOpenUpdateDeliveredAt(order.order_id,order.delivered_at,order.slot_id)}>
                        Update Delivered At
                      </Button>}
                      <Tooltip title="View Histories">
                        <HistoryIcon style={{cursor: "pointer"}} className="text-success ml-2" onClick={() => HandleOpenUpdateSlot(true,order)}></HistoryIcon>
                      </Tooltip>
                    </div>
                  }
                </td>
              </Can>
            </tr>
        ));
      }

      const renderSelectAllCheckBox = () => {
        if(orderIDs.length && orderList.length){
          const isSelectedAll = orderList.every(x => orderIDs.includes(x.order_id));
          const isSelectedSome = orderList.some(x => orderIDs.includes(x.order_id));

          if(isSelectedAll){
            return (<Checkbox
                checked={isSelectedAll}
                onChange={() => bulkSelectionAll()}
                color="primary"
                inputProps={{ 'aria-label': 'secondary checkbox' }}
            />)
          }else if(isSelectedSome){
            return (<Checkbox
                checked={isSelectedSome}
                indeterminate
                color="primary"
                onChange={() => bulkSelectionAll()}
                inputProps={{ 'aria-label': 'indeterminate checkbox' }}
            />);
          }else{
            return (<Checkbox
                checked={false}
                onChange={() => bulkSelectionAll()}
                color="primary"
                inputProps={{ 'aria-label': 'secondary checkbox' }}
            />);
          }
        }else{
          return <Checkbox
              checked={false}
              onChange={() => bulkSelectionAll()}
              color="primary"
              inputProps={{ 'aria-label': 'secondary checkbox' }}
          />
        }
      }

// Pagination
      let pageItems = [
        <Pagination.Item disabled={next <= limit} key={0} onClick={handlePaginPrev}>
          Prev
        </Pagination.Item>
        ,
        <Form.Group key={1} controlId="formGridPagination">
          <InputGroup>
            <InputGroup.Prepend>
              <InputGroup.Text>{`${next} / ${totalNumberList}`}</InputGroup.Text>
            </InputGroup.Prepend>
          </InputGroup>
        </Form.Group>
        ,
        <Pagination.Item disabled={Number(next) === Number(totalNumberList)} key={2} onClick={handlePaginNext}>
          Next
        </Pagination.Item>
        ,
      ];
      const PaginationBasic = () => (
          <div className="d-flex justify-content-center">
            <Pagination>{pageItems}</Pagination>
          </div>
      );

      return (
        <CustomModal>
          <HelpPageWrapper>
            {isSelected ? (
              <Row className="mb-5">
                <Col sm={9}>
                  <Row>
                    <Col>
                      <Button
                        variant="success"
                        onClick={() => handleBulkSubmit(2)}
                      >
                        Mark as New
                      </Button>
                    </Col>

                    <Col>
                      <Button
                        variant="success"
                        onClick={() => handleBulkSubmit(3)}
                      >
                        Mark as Accept
                      </Button>
                    </Col>

                    <Col>
                      <Button
                        variant="success"
                        onClick={() => handleBulkSubmit(4)}
                      >
                        Mark as Packed
                      </Button>
                    </Col>

                    <Col>
                      <Button
                        variant="success"
                        onClick={() => handleBulkSubmit(5)}
                      >
                        Mark as On The Way
                      </Button>
                    </Col>

                    <Col>
                      <Button
                        variant="success"
                        onClick={() => handleBulkSubmit(6)}
                      >
                        Mark as Delivered
                      </Button>
                    </Col>

                    <Col>
                      <Button
                        variant="success"
                        onClick={() => handleBulkSubmit(8)}
                      >
                        Mark as Arrived
                      </Button>
                    </Col>

                        <Col>
                          <Button variant="success" onClick={() => handleOpenConfirmModalOrdersSelect()}>
                            Mark as Cancel
                          </Button>
                        </Col>
                      </Row>
                    </Col>

                <Col sm={3}>
                  {accept || dispatch ? (
                    <Row>
                      <Col>
                        <Button
                          className="bg-danger"
                          variant="danger"
                          onClick={() => setIsOpenModalConfirmPickupFile(true)}
                        >
                          Send Pickup File
                        </Button>
                      </Col>

                      <Col>
                        <Button
                          className="bg-danger"
                          variant="danger"
                          onClick={() =>
                            setIsOpenModalConfirmfSendMultiInvoiceFile(true)
                          }
                        >
                          Send Invoice/Order File
                        </Button>
                      </Col>
                    </Row>
                  ) : (
                    <></>
                  )}
                </Col>
              </Row>
            ) : (
              // [
              //     <div className="d-flex justify-content-between" key={1}>
              //         <Button
              //             disabled={isRequesting}
              //             variant={status === 2345678 ? secondary : success}
              //             type="submit"
              //             className="mb-5"
              //             onClick={() =>
              //                 handleGetOrderByStatus({
              //                     status: 2345678,
              //                     isShowAccptedHasDriver: false,
              //                 })
              //             }
              //         >
              //             All {getOrderStatusCountByLabel("All")}
              //         </Button>
              //         <Button
              //             disabled={isRequesting}
              //             variant={status === 2 ? secondary : success}
              //             type="submit"
              //             className="mb-5"
              //             onClick={() =>
              //                 handleGetOrderByStatus({
              //                     status: 2,
              //                     isShowAccptedHasDriver: false,
              //                 })
              //             }
              //         >
              //             New {getOrderStatusCountByLabel("New")}
              //         </Button>
              //         <Button
              //             disabled={isRequesting}
              //             variant={
              //                 status === 3 && !isShowOnlyAcceptedHasDriver
              //                     ? secondary
              //                     : success
              //             }
              //             type="submit"
              //             className="mb-5"
              //             onClick={() =>
              //                 handleGetOrderByStatus({
              //                     status: 3,
              //                     isShowAccptedHasDriver: false,
              //                 })
              //             }
              //         >
              //             Accepted {getOrderStatusCountByLabel("Accepted")}
              //         </Button>
              //         <Button
              //             disabled={isRequesting}
              //             variant={
              //                 status === 3 && isShowOnlyAcceptedHasDriver
              //                     ? secondary
              //                     : success
              //             }
              //             type="submit"
              //             className="mb-5"
              //             onClick={() =>
              //                 handleGetOrderByStatus({
              //                     status: 3,
              //                     isShowAccptedHasDriver: true,
              //                 })
              //             }
              //         >
              //             Assigned to driver{" "}
              //             {getOrderStatusCountByLabel("Assigned to driver")}
              //         </Button>
              //         <Button
              //             disabled={isRequesting}
              //             variant={status === 45 ? secondary : success}
              //             type="submit"
              //             className="mb-5"
              //             onClick={() =>
              //                 handleGetOrderByStatus({
              //                     status: 45,
              //                     isShowAccptedHasDriver: false,
              //                 })
              //             }
              //         >
              //             Packed & Dispatched{" "}
              //             {getOrderStatusCountByLabel("Packed & Dispatched")}
              //         </Button>
              //         <Button
              //             disabled={isRequesting}
              //             variant={status == 8 ? secondary : success}
              //             type="submit"
              //             className="mb-5"
              //             onClick={() =>
              //                 handleGetOrderByStatus({
              //                     status: 8,
              //                     isShowAccptedHasDriver: false,
              //                 })
              //             }
              //         >
              //             Arrived {getOrderStatusCountByLabel("Arrived")}
              //         </Button>
              //         {/* <Button disabled={isRequesting} variant={status == 6 ? secondary : success} type="submit" className="mb-5" onClick={() => handleGetOrderByStatus(6, false)}>
              //             Delivered {orderStatusCount.delivered ? "(" + orderStatusCount.delivered + ")" : ""}
              //         </Button> */}
              //         <Button
              //             disabled={isRequesting}
              //             variant={status == 7 ? secondary : success}
              //             type="submit"
              //             className="mb-5"
              //             onClick={() =>
              //                 handleGetOrderByStatus({
              //                     status: 7,
              //                     isShowAccptedHasDriver: false,
              //                 })
              //             }
              //         >
              //             Cancelled {getOrderStatusCountByLabel("Cancelled")}
              //         </Button>
              //     </div>,
              //     <Row className="mb-4" key={2}>
              //         <Col sm={8}>
              //             {/*<Form.Control*/}
              //                 {/*style={{width: "25rem"}}*/}
              //                 {/*size="md"*/}
              //                 {/*type="text"*/}
              //                 {/*placeholder="Search customers"*/}
              //                 {/*onChange={(e) => handleSearch(e.target.value)}*/}
              //             {/*/>*/}
              //             <Form.Control
              //                 as="select"
              //                 onChange={(e) => handleSelectOrderStatus(e)}
              //                 value={selectedStatus}
              //                 disabled={isRequesting}
              //             >
              //                 {orderStatusOpts.map((oStatus, index) => (
              //                     <option value={index} key={index}>
              //                         {oStatus.label}{" "}
              //                         {getOrderStatusCountByLabel(oStatus.label)}
              //                     </option>
              //                 ))}
              //             </Form.Control>
              //             &nbsp;&nbsp;
              //             <Datetime style={{width: "300px"}}
              //                       value={startDate}
              //                       dateFormat="YYYY-MM-DD"
              //             />
              //             &nbsp;&nbsp;
              //             <Datetime style={{width: "300px"}}
              //                       value={endDate}
              //                       dateFormat="YYYY-MM-DD"
              //             />
              //             <Button
              //                 variant="primary"
              //                 className="btn-primary"
              //                 onClick={console.log()}
              //             >
              //                 Filter
              //             </Button>
              //             <Button
              //                 variant="info"
              //                 className="btn-info"
              //                 onClick={console.log()}
              //             >
              //                 Clear
              //             </Button>
              //         </Col>
              //         <Col sm={4} className="d-flex justify-content-end">
              //             <span style={labelStyle}>Filter: </span>
              //             &nbsp;&nbsp;
              //             <Form.Control
              //                 as="select"
              //                 onChange={(e) => setSelectedBasketType(e.target.value)}
              //                 value={selectedBasketType}
              //             >
              //                 <option value={""}>All Type</option>
              //                 <option value={"0"}>Normal</option>
              //                 <option value={"1"}>Express</option>
              //             </Form.Control>
              //         </Col>
              //     </Row>,
              // ]
              <Row className="mb-4" key={2}>
                <Col sm={2}>
                  <Form.Control
                    as="select"
                    onChange={(e) => handleSelectOrderStatus(e)}
                    value={selectedStatus}
                    disabled={isRequesting}
                  >
                    {orderStatusOpts.map((oStatus, index) => (
                      <option value={index} key={index}>
                        {oStatus.label}{" "}
                        {getOrderStatusCountByLabel(oStatus.label)}
                      </option>
                    ))}
                  </Form.Control>
                </Col>

                <Col sm={1} style={{ padding: "0px" }}>
                  <Form.Control
                    as="select"
                    onChange={(e) => handleOrderTypeChange(e)}
                    value={selectedBasketType}
                    disabled={isRequesting}
                  >
                    <option value={""}>All Type</option>
                    <option value={"0"}>Normal</option>
                    <option value={"1"}>Express</option>
                  </Form.Control>
                </Col>
                <Col sm={2}>
                  <Datetime
                    style={{ width: "300px" }}
                    ref={startDateFilterRef}
                    disabled={isRequesting}
                    value={startDateFilter ? startDateFilter : ""}
                    dateFormat="YYYY-MM-DD"
                    timeFormat={false}
                    closeOnSelect={true}
                    inputProps={{ placeholder: "Start Delivering Date" }}
                    onChange={handleChangeStartDate}
                  />
                </Col>

                <Col sm={2} style={{ padding: "0px" }}>
                  <Datetime
                    style={{ width: "300px" }}
                    disabled={isRequesting}
                    ref={endDateFilterRef}
                    closeOnSelect={true}
                    value={endDateFilter ? endDateFilter : ""}
                    dateFormat="YYYY-MM-DD"
                    timeFormat={false}
                    inputProps={{ placeholder: "End Delivering Date" }}
                    onChange={handleChangeEndDate}
                  />
                </Col>
                <Col sm={2} className="">
                  <Form.Control
                    style={{}}
                    size="md"
                    type="text"
                    disabled={isRequesting}
                    placeholder="Search order id, customers or amount"
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                </Col>
                <Col sm={3} className="d-flex justify-content-end">
                  {/* <Button
                          variant="primary"
                          className="btn-primary"
                          onClick={handleFilter}
                          disabled={isRequesting}
                      >
                        <Filter></Filter>&nbsp;&nbsp;Filter
                      </Button>
                      &nbsp;&nbsp; */}
                  <Button
                    variant="info"
                    className="btn-info"
                    disabled={isRequesting || isProductRequest}
                    onClick={handlePrintDital}
                  >
                    Extract Report
                  </Button>
                  &nbsp;&nbsp;
                  <Button
                    variant="info"
                    className="btn-info"
                    disabled={isRequesting}
                    onClick={handleClearFilter}
                  >
                    Clear
                  </Button>
                </Col>
              </Row>
            )}

            {!isRequesting && [45, 6, 7, -1, 2345678].includes(status) && (
              <Row>
                <Col
                  sm={12}
                  className="d-flex justify-content-end align-items-center"
                >
                  <PaginationBasic />
                </Col>
              </Row>
            )}
            <Row>
              <Col sm={12}>
                {isRequesting ? (
                  <div style={{ position: "fixed", left: "55%", top: "35%" }}>
                    {" "}
                    <Loader color="#9cc54b" h="100" />{" "}
                  </div>
                ) : (
                  <TableBodyWidth
                    className="table-responsive"
                    style={{ overflowY: "hidden" }}
                  >
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          {status === 2345678 && (
                            <th
                              style={{ minWidth: "12vh", cursor: "pointer" }}
                              onClick={() => handleSortOrder("status")}
                            >
                              Status{" "}
                              {orderField === "status"
                                ? orderType === "DESC"
                                  ? DownArrow
                                  : UpArrow
                                : UpDownArrow}
                            </th>
                          )}
                          {query ? null : <th>{renderSelectAllCheckBox()}</th>}
                          <th></th>
                          <th
                            onClick={() => handleSortOrder("order_id")}
                            style={{ cursor: "pointer" }}
                          >
                            Order ID{" "}
                            {orderField === "order_id"
                              ? orderType === "DESC"
                                ? DownArrow
                                : UpArrow
                              : UpDownArrow}
                          </th>
                          <th
                            onClick={() => handleSortOrder("customer_name")}
                            style={{ cursor: "pointer" }}
                          >
                            Customer{" "}
                            {orderField === "customer_name"
                              ? orderType === "DESC"
                                ? DownArrow
                                : UpArrow
                              : UpDownArrow}
                          </th>
                          <th
                            style={{ minWidth: "10vh" }}
                            className="text-center"
                          ></th>
                          {/*{status === 45 && <th>Status</th>}*/}
                          {/*<th>Order Date</th>*/}
                          <th
	                          onClick={() => handleSortOrder("amount")}
                            style={{ cursor: "pointer" }}
                          >
                            Amount{" "}
	                          {orderField === "amount"
                              ? orderType === "DESC"
                                ? DownArrow
                                : UpArrow
                              : UpDownArrow}
                          </th>
	                        <th>Remaining</th>
	                        <th>City</th>
                          <th
                            style={{ width: "22vh", cursor: "pointer" }}
                            onClick={() =>
                              handleSortOrder("payment_method_name")
                            }
                          >
                            Payment Type{" "}
                            {orderField === "payment_method_name"
                              ? orderType === "DESC"
                                ? DownArrow
                                : UpArrow
                              : UpDownArrow}
                          </th>
                          {status === -1 ? <th>Out Trade No</th> : null}
                          <th>Order Date</th>
                          <th
                            onClick={() => handleSortOrder("start_time")}
                            style={{ cursor: "pointer" }}
                          >
                            Delivery Date/Time{" "}
                            {orderField === "start_time"
                              ? orderType === "DESC"
                                ? DownArrow
                                : UpArrow
                              : UpDownArrow}
                          </th>
                          {/*<th>Type</th>*/}
                          {/*<th>Address</th>*/}
                          {status !== 3 && !(accept || dispatch) && !query && (
                            <th
                              className="text-center"
                              onClick={() => handleSortOrder("driver_name")}
                              style={{ cursor: "pointer" }}
                            >
                              Assign To{" "}
                              {orderField === "driver_name"
                                ? orderType === "DESC"
                                  ? DownArrow
                                  : UpArrow
                                : UpDownArrow}
                            </th>
                          )}
                          {status !== 3 && !(accept || dispatch) && !query && (
                            <th
                              className="text-center"
                            >
                              Secondary Driver
                            </th>
                          )}
                          {(accept || dispatch) && !query ? (
                            <>
                              {dispatch && (
                                <th className="text-center">Assign To</th>
                              )}
                              {dispatch && (<th className="text-center">Secondary Driver</th>)}
                              {accept && (
                                <th className="text-center">Accept</th>
                              )}
                              <th>Cancel</th>
                              <th
                                className="text-center"
                                style={{ maxWidth: "13vh" }}
                              >
                                <span>
                                  Invoice
                                  <br />
                                  /Order file
                                </span>
                              </th>
                            </>
                          ) : (
                            <></>
                          )}
                          {query ? <th>Query Order</th> : null}
                          {/*{!(accept || dispatch) ? (*/}
                          {/*<>*/}
                          {/*<th*/}
                          {/*style={{minWidth: "18vh"}}*/}
                          {/*className="text-center"*/}
                          {/*>*/}
                          {/*Cust. Wallet*/}
                          {/*</th>*/}
                          {/*</>*/}
                          {/*) : (*/}
                          {/*<></>*/}
                          {/*)}*/}

                          <Can
                            headPermit="Orders" 
                            keyPermit="orders_change_time_slot"
                          >
                            <th>Time Slot</th>
                          </Can>
                        </tr>
                      </thead>
                      <tbody>
                        {orderList && orderList.length ? (
                          content
                        ) : (
                          <tr>
	                          <td colSpan={15} className="text-center">
                              No data
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </TableBodyWidth>
                )}

                <Modal
                  show={isOpenModalAddDriver}
                  onHide={handleCloseModalAddDriver}
                  aria-labelledby="contained-modal-title-vcenter"
                  size="xl"
                  centered
                  className="bd-example-modal-xl"
                >
                  <Form noValidate validated={validated} autoComplete="false">
                    <Modal.Header closeButton>
                      <Modal.Title>Add driver</Modal.Title>
                    </Modal.Header>
                    <Modal.Body key="modalBody">
                      {driverList.length ? (
                        <Row>
                          {driverList.map((driver, index) => (
                            <Col sm={3} key={driver.id}>
                              <input
                                type="radio"
                                id={`custom-checkbox-${driver.id}`}
                                name={driver.id}
                                value={driver.id}
                                onChange={() => handleSelectDriver(driver.id)}
                                checked={
                                  driverList[index].id === selectedDriver
                                }
                              />
                              <label htmlFor={`custom-checkbox-${driver.id}`}>
                                &nbsp;&nbsp;{driver.first_name}{" "}
                                {driver.last_name}
                              </label>
                            </Col>
                          ))}
                        </Row>
                      ) : null}
                    </Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary" disabled={isRequestingUpsert} onClick={handleCloseModalAddDriver}>
                      Close
                    </Button>
                    {selectedDriver && driverType === "secondary" && <Button variant="danger" onClick={()=> handleRemoveSecondaryDriver()}
                      >
                      Remove Driver
                    </Button>
                    }
                      <Button
                        variant="primary"
                        onClick={handleSubmit}
                        disabled={isRequestingUpsert}
                      >
                        {isRequestingUpsert ? (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : null}

                          <span className="pl-2 pr-2">Add</span>
                        </Button>
                      </Modal.Footer>
                    </Form>
                  </Modal>

                  {/* Modal confirm cancel all orders seleted*/}
                  <Modal
                      show={isShowConfirmModalOrder}
                      animation={false}
                      onHide={handleCloseConfirmModalOrdersSelect}
                      aria-labelledby="contained-modal-title-vcenter"
                      size="xs"
                      centered
                  >
                    <Modal.Header closeButton className="bg-danger">
                      <Modal.Title className="text-white">Warning</Modal.Title>
                    </Modal.Header>
                    <Modal.Body key="modalBody" className="text-center">
                      <Form.Label>Are you sure you want to cancel?</Form.Label>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center">
                      <Button
                          variant="danger"
                          onClick={(e) => handleBulkSubmit(7)}
                      >
                        OK
                      </Button>
                      <Button variant="secondary" onClick={handleCloseConfirmModalOrdersSelect}>
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>

                {/* Modal confirm cancel */}
                <Modal
                  show={isShowConfirmModal}
                  animation={false}
                  onHide={handleCloseConfirmModal}
                  aria-labelledby="contained-modal-title-vcenter"
                  size="xs"
                  centered
                >
                  <Modal.Header closeButton className="bg-danger">
                    <Modal.Title className="text-white">Warning</Modal.Title>
                  </Modal.Header>
                  <Modal.Body key="modalBody" className="text-center">
                    <Form.Label>Do you wnat to cancel the order?</Form.Label>
                  </Modal.Body>
                  <Modal.Footer className="d-flex justify-content-center">
                    <Button
                      variant="danger"
                      onClick={(e) => handleChangeStatus(orderIdToCancel, 7)}
                    >
                      OK
                    </Button>
                    <Button
                      variant="secondary"
                      onClick={handleCloseConfirmModal}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>

                {/* Modal add wallet */}
                <Modal
                  show={isShowAddWalletTranModal}
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                  size="xs"
                  onHide={handleCloseAddWalletTransactionModal}
                >
                  <Form noValidate validated={validated} autoComplete="false">
                    <Modal.Header closeButton>
                      <Modal.Title>Update funds</Modal.Title>
                    </Modal.Header>
                    <Modal.Body key="modalBody">
                      <Form.Group controlId="formTransactionType">
                        <Form.Label>Transaction Type</Form.Label>
                        <InputGroup hasvalidation="true">
                          <Form.Control
                            as="select"
                            onChange={(e) => setTransactionType(e.target.value)}
                            value={transactionType}
                            isInvalid={walletFormError.transactionType}
                            required
                            disabled={isWalletRequesting}
                            placeholder="Select"
                          >
                            <option value={"credit"}>Credit</option>
                            <option value={"debit"}>Debit</option>
                          </Form.Control>
                        </InputGroup>
                      </Form.Group>

                      <Form.Group controlId="amount">
                        <Form.Label>Amount(USD)</Form.Label>
                        <InputGroup hasvalidation="true">
                          <Form.Control
                            isInvalid={walletFormError.walletAmount}
                            type="number"
                            placeholder="00.00 USD"
                            value={walletAmount}
                            disabled={isWalletRequesting}
                            onChange={(e) => setWalletAmount(e.target.value)}
                          />
                        </InputGroup>
                      </Form.Group>

                      <Form.Group controlId="reason">
                        <Form.Label>Reason</Form.Label>
                        <InputGroup hasvalidation="true">
                          <Form.Control
                            as="select"
                            onChange={(e) => setReason(e.target.value)}
                            value={reason}
                            isInvalid={walletFormError.reason}
                            required
                            disabled={isWalletRequesting}
                            placeholder="Select"
                          >
                            <option value={"marketing"}>Marketing</option>
                            <option value={"order"}>Order</option>
                            <option value={"refund"}>Refund</option>
                            <option value={"other"}>Other</option>
                          </Form.Control>
                        </InputGroup>
                      </Form.Group>

                      <Form.Group controlId="comment">
                        <Form.Label>Comment</Form.Label>
                        <InputGroup hasvalidation="true">
                          <Form.Control
                            as="textarea"
                            rows={3}
                            disabled={isWalletRequesting}
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                          />
                        </InputGroup>
                      </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        disabled={isWalletRequesting}
                        variant="primary"
                        onClick={handleSummitAddWallet}
                      >
                        {isWalletRequesting ? (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : null}

                        <span className="pl-2 pr-2">Update</span>
                      </Button>

                      <Button
                        disabled={isWalletRequesting}
                        variant="secondary"
                        onClick={handleCloseAddWalletTransactionModal}
                      >
                        Close
                      </Button>
                    </Modal.Footer>
                  </Form>
                </Modal>

                {/* Modal display wallet list */}
                <Modal
                  show={isShowWalletTransactionModal}
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                  size="lg"
                  onHide={handleCloseWalletTransactionModal}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      <Row>
                        <Col sm={12}>
                          Wallet Historic of customer :{" "}
                          {orderToViewWallet &&
                          orderToViewWallet.customer_detail
                            ? orderToViewWallet.customer_detail.name
                            : ""}
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={12}>
                          (
                          {orderToViewWallet &&
                          orderToViewWallet.customer_detail &&
                          orderToViewWallet.customer_detail.wallet
                            ? getFormatCurrencyForDisplay(
                                orderToViewWallet.customer_detail.wallet
                                  .wallet_amount
                              )
                            : getFormatCurrencyForDisplay(0)}
                          )
                        </Col>
                      </Row>
                    </Modal.Title>
                  </Modal.Header>

                  <Modal.Body>
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>User</th>
                          <th>Type</th>
                          <th>Reason</th>
                          <th>Creation Date/Time</th>
                          <th className="text-center">Amount</th>
                        </tr>
                      </thead>

                      <tbody>
                        {walletTransactionList.length ? (
                          [
                            walletTransactionList.map((item, index) => (
                              <tr key={index}>
                                <td>{item.admin_info}</td>
                                <td>{_.capitalize(item.transaction_type)}</td>
                                <td>{_.capitalize(item.reason)}</td>
                                <td>
                                  {getFormatDateForDisplay(item.createdAt)}
                                </td>
                                <td className="text-right">
                                  {getFormatCurrencyForDisplay(
                                    item.wallet_amount
                                  )}
                                </td>
                              </tr>
                            )),
                          ]
                        ) : isWalletRequesting ? (
                          <tr>
                            <td colSpan={14} className="text-center">
                              <Spinner animation="grow" />
                            </td>
                          </tr>
                        ) : (
                          <tr>
                            <td colSpan={14} className="text-center">
                              No data
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Modal.Body>

                  <Modal.Footer>
                    <Button
                      disabled={isWalletRequesting}
                      variant="danger"
                      onClick={handleCloseWalletTransactionModal}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Modal
                  show={modalQueryOpen}
                  onHide={() => setModalQueryOpen(false)}
                  centered
                  backdrop="false"
                >
                  <Modal.Header>
                    <Modal.Title>Payment Details</Modal.Title>
                    <small>
                      Created at:{" "}
                      {getFormatDateForDisplay(queryData?.created_at)}
                    </small>
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col sm="12">
                        <div className="d-flex flex-column">
                          <div className="d-flex align-items-center">
                            <strong className="d-block mr-2">
                              Payment Method:
                            </strong>
                            <p>
                              {queryData?.meta?.setting?.enabled_payment_methods[0]?.replace(
                                "_",
                                " "
                              )}
                            </p>
                          </div>
                          {queryData?.card_info &&
                          queryData?.card_info?.holder_name &&
                          queryData?.card_info?.account_number ? (
                            <>
                              <div className="d-flex align-items-center mt-1">
                                <strong className="d-block mr-2">
                                  Holder Name:
                                </strong>
                                <p>{queryData?.card_info?.holder_name}</p>
                              </div>
                              <div className="d-flex align-items-center mt-1">
                                <strong className="d-block mr-2">
                                  Account Number:
                                </strong>
                                <p>{queryData?.card_info?.account_number}</p>
                              </div>
                            </>
                          ) : null}
                          <div className="d-flex align-items-center mt-1">
                            <strong className="d-block mr-2">
                              Amount to Pay:
                            </strong>
                            <p>
                              {getFormatCurrencyForDisplay(
                                queryData?.total_amount
                              )}
                            </p>
                          </div>
                          <div className="d-flex align-items-center mt-1">
                            <strong className="d-block mr-2">Status:</strong>
                            <p>{queryData?.status}</p>
                          </div>
                          <div className="d-flex align-items-center mt-1">
                            <strong className="d-block mr-2">
                              Out Trade No:
                            </strong>
                            <p className="text-primary">
                              {queryData?.out_trade_no}
                            </p>
                          </div>
                          <div className="d-flex align-items-center mt-1">
                            <strong className="d-block mr-2">Token:</strong>
                            <p className="text-primary">{queryData?.token}</p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="outline-secondary"
                      onClick={() => setModalQueryOpen(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="primary"
                      disabled={["waiting", "closed"].includes(
                        queryData?.status?.toLowerCase()
                      )}
                      onClick={handleApproveOrder}
                    >
                      Approve
                    </Button>
                  </Modal.Footer>
                </Modal>

                <AvailableDeliverySlotModal
                  show={showSchedule}
                  handleCloseDialog={handleDeliverySlotCloseModal}
                  selectedSlot={selectedSlot}
                  onSlotSelected={onSlotSelected}
                  pageName="admin-orders"
                  orderId={queryOrderId}
                />
              </Col>
            </Row>

            <Toast
              className={toastBgColor}
              onClose={() => setShowToast(false)}
              show={showToast}
              autohide
              style={{
                position: "fixed",
                top: 70,
                right: 35,
                zIndex: 1041,
                width: "300px",
              }}
            >
              <Toast.Header>
                <strong className="mr-auto m-3">{toastMessage}</strong>
              </Toast.Header>
            </Toast>

            {/*
                    Modal confirm invoice send file
                  */}
            <Dialog
              open={isOpenModalConfirmSendFile}
              onClose={handleCloseModalConfirmSendFile}
            >
              <DialogTitle>Send invoice/order file</DialogTitle>
              <DialogContent dividers>
                <DialogContentText id="alert-dialog-description">
                  Do you want to send invoice/order file?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="primary"
                  disabled={isRequestingSendFile}
                  onClick={(e) => handleGenerateInvoice(orderIdToSendFile)}
                >
                  {isRequestingSendFile ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : null}

                  <span className="pl-2 pr-2">Send</span>
                </Button>

                <Button
                  disabled={isRequestingSendFile}
                  variant="secondary"
                  onClick={handleCloseModalConfirmSendFile}
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>

            {/*
                    Modal confirm send pick up
                  */}
            <Dialog
              open={isOpenModalConfirmPickupFile}
              onClose={() => setIsOpenModalConfirmPickupFile(false)}
            >
              <DialogTitle>Send pickup file</DialogTitle>
              <DialogContent dividers>
                <DialogContentText id="alert-dialog-description">
                  Do you want to send pickup file?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="primary"
                  disabled={isRequestingSendPickupFile}
                  onClick={handlePickup}
                >
                  {isRequestingSendPickupFile ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : null}

                  <span className="pl-2 pr-2">Send</span>
                </Button>

                <Button
                  disabled={isRequestingSendPickupFile}
                  variant="secondary"
                  onClick={() => setIsOpenModalConfirmPickupFile(false)}
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>

	          {/*
                    Modal confirm send multi invoice/order file
                  */}
            <Dialog
              open={isOpenModalConfirmSendMultiInvoiceFile}
              onClose={() => setIsOpenModalConfirmfSendMultiInvoiceFile(false)}
            >
              <DialogTitle>Send invoice/order file</DialogTitle>
              <DialogContent dividers>
                <DialogContentText id="alert-dialog-description">
                  Do you want to send invoice/order file?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="primary"
                  disabled={isRequestingSendMultiInvoiceFile}
                  onClick={handleBulkGenerateInvoice}
                >
                  {isRequestingSendMultiInvoiceFile ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : null}

                  <span className="pl-2 pr-2">Send</span>
                </Button>

                <Button
                  disabled={isRequestingSendMultiInvoiceFile}
                  variant="secondary"
                  onClick={() =>
                    setIsOpenModalConfirmfSendMultiInvoiceFile(false)
                  }
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>

            {/*
                    Modal option extract xlsx report
                  */}
            <Dialog
              open={isOpenModalExtractReport}
              onClose={() => setIsOpenModalExtractReport(false)}
              maxWidth="xs"
              minWidth="xs"
              fullWidth
            >
              <DialogTitle className="text-center">
                <FilterNoneIcon /> Extract Report
              </DialogTitle>
              <DialogContent dividers>
                <DialogContentText id="alert-dialog-description">
                  <FormControl component="fieldset">
                    <RadioGroup
                      aria-label="quiz"
                      name="quiz"
                      value={value}
                      onChange={handleChangeReport}
                    >
                      <FormControlLabel
                        value={"0"}
                        control={<Radio color="primary" />}
                        label={<span className="text-dark">Orders report</span>}
                      />
                      <FormControlLabel
                        value={"1"}
                        control={<Radio color="primary" />}
                        label={
                          <span className="text-dark">
                            Product Order Tracking
                          </span>
                        }
                      />
                    </RadioGroup>
                    <FormHelperText></FormHelperText>
                  </FormControl>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button variant="primary">
                  <span
                    className="pl-2 pr-2"
                    onClick={handleSubmitExtractReport}
                  >
                    Extract
                  </span>
                </Button>

                <Button variant="secondary">
                  <span
                    className="pl-2 pr-2"
                    onClick={() => setIsOpenModalExtractReport(false)}
                  >
                    Dimiss
                  </span>
                </Button>
              </DialogActions>
            </Dialog>

            {/* update order histories modal */}
	          {showUpdateSchedule && <UpdateAvailableDeliverySlotModal
		          show={showUpdateSchedule}
		          handleCloseDialog={handleCloseDeliverySlotModal}
		          selectedSlot={selectedUpdateSlot}
		          onSlotSelected={onUpdateSlotSelected}
		          pageName="admin-orders"
		          orderId={getOrderId}
		          slotId={selectedSlot}
		          order={selectedOrder}
		          updatingSlot={updatingSlot}
	          />}
            {/* Dialog Open Update Delivered At */}
            <Dialog
              open={deliveredAtModal}
              onClose={() => handleCloseUpdateDeliveredAt(false)}
              maxWidth="xs"
              minWidth="xs"
              fullWidth
            >
              <DialogTitle className="">
                <HistoryIcon />
                Update Delivered Date
              </DialogTitle>
              <DialogContent dividers>
                <DialogContentText id="alert-dialog-description">
                  <form noValidate>
                    <TextField
                      id="datetime-local"
                      label="Delivered Date"
                      type="datetime-local"
                      defaultValue={deliveredAt}
                      onChange={(e) => handleChangeDeliveredAt(e)}
                      className="w-100"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </form>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button variant="secondary">
                  <span
                    className="pl-2 pr-2"
                    onClick={() => handleCloseUpdateDeliveredAt(false)}
                  >
                    Close
                  </span>
                </Button>
                <Button variant="primary">
                  <span
                    className="pl-2 pr-2"
                    onClick={() => onUpdateDeliveredAt()}
                  >
                    Update
                  </span>
                </Button>
              </DialogActions>
            </Dialog>
            {/* Dialog Open Update order Histories */}
            <Dialog
              open={slotHistoryModal}
              onClose={() => HandleCloseUpdateSlot(false)}
              maxWidth="lg"
              minWidth="lg"
              fullWidth
            >
              <DialogTitle className="">
                <HistoryIcon />
                Update Histories
              </DialogTitle>
              <DialogContent dividers>
                <TableContent>
                  <Paper>
                    <TableContainer
                      style={{ maxHeight: window.innerHeight - 280 }}
                    >
                      <MTable stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell align="left">orderID</TableCell>
                            <TableCell align="left">Field</TableCell>
                            <TableCell align="left">Value New</TableCell>
                            <TableCell align="left">Value Old</TableCell>
                            <TableCell align="left">Comment</TableCell>
                            <TableCell align="left">User Name</TableCell>
                            <TableCell align="left">Modified at</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody style={{ position: "relative" }}>
                          {listUpdateHistories.list.length > 0 ? (
                            listUpdateHistories.list.map((row, idx) => {
                              return (
                                <TableRow hover>
                                  <TableCell>{row.order_id}</TableCell>
                                  <TableCell>{row.field}</TableCell>
                                  <TableCell>
                                    {
                                    row.field === "timeslot_start_time" ? (
                                      row.value_new ? (
                                        moment(row.value_new).format(
                                          "DD/MMM/YY - hh:mm A"
                                        )
                                      ) : (
                                        "-"
                                      )
                                    )
	                                    : row.field === "timeslot_full_day" ? row.value_new :
                                    row.field === "driver_id" ? (
                                      row.value_new ? row.value_new:"-"
                                    ) 
                                    :
                                    row.field === "secondary_driver_id" ? (
                                      row.value_new ? row.value_new:"-"
                                    )    
                                    : row.field === "delivered_at" ? (
                                      row.value_new ? (
                                        moment(row.value_new).format(
                                          "DD/MMM/YY - hh:mm A"
                                        )
                                      ) : (
                                        "-"
                                      )
                                    ) 
                                    : row.field === "order_status" ? (
                                      row.value_new == 2 ? (
                                        <Button
                                          variant="success"
                                          style={{
                                            backgroundColor: "#ED9704",
                                            width: "12vh",
                                            border: "none",
                                            cursor: "auto",
                                            outline: "none",
                                            boxShadow: "none",
                                            color: "#ffffff",
                                          }}
                                        >
                                          New
                                        </Button>
                                      ) : row.value_new == 3 ? (
                                        <Button
                                          variant="success"
                                          style={{
                                            backgroundColor: "#F30A0B",
                                            width: "12vh",
                                            border: "none",
                                            cursor: "auto",
                                            outline: "none",
                                            boxShadow: "none",
                                            color: "#ffffff",
                                          }}
                                        >
                                          Accepted
                                        </Button>
                                      ) : row.value_new == 4 ? (
                                        <Button
                                          variant="success"
                                          style={{
                                            backgroundColor: "#4D4C5C",
                                            width: "12vh",
                                            border: "none",
                                            cursor: "auto",
                                            outline: "none",
                                            boxShadow: "none",
                                            color: "#ffffff",
                                          }}
                                        >
                                          Packed
                                        </Button>
                                      ) : row.value_new == 5 ? (
                                        <Button
                                          variant="success"
                                          style={{
                                            backgroundColor: "#56E76F",
                                            width: "12vh",
                                            border: "none",
                                            cursor: "auto",
                                            outline: "none",
                                            boxShadow: "none",
                                            color: "#ffffff",
                                          }}
                                        >
                                          On the way
                                        </Button>
                                      ) : row.value_new == 6 ? (
                                        <Button
                                          variant="success"
                                          style={{
                                            backgroundColor: "#49A641",
                                            width: "12vh",
                                            border: "none",
                                            cursor: "auto",
                                            outline: "none",
                                            boxShadow: "none",
                                            color: "#ffffff",
                                          }}
                                        >
                                          Delivered
                                        </Button>
                                      ) : row.value_new == 7 ? (
                                        <Button
                                          variant="success"
                                          style={{
                                            backgroundColor: "#A10559",
                                            width: "12vh",
                                            border: "none",
                                            cursor: "auto",
                                            outline: "none",
                                            boxShadow: "none",
                                            color: "#ffffff",
                                          }}
                                        >
                                          Cancelled
                                        </Button>
                                      ) : row.value_new == 8 ? (
                                        <Button
                                          variant="success"
                                          style={{
                                            backgroundColor: "#7E481C",
                                            width: "12vh",
                                            border: "none",
                                            cursor: "auto",
                                            outline: "none",
                                            boxShadow: "none",
                                            color: "#ffffff",
                                          }}
                                        >
                                          Arrived
                                        </Button>
                                      ) : null
                                    ) : null}
                                  </TableCell>
                                  <TableCell>
                                    {row.field ==="timeslot_start_time" ? (
                                      row.value_old ? (
                                        moment(row.value_old).format(
                                          "DD/MMM/YY - hh:mm A"
                                        )
                                      ) : (
                                        "-"
                                      )
                                    ) : row.field === "timeslot_full_day" ? row.value_old :
                                    row.field === "driver_id" ? (
                                      row.value_old ? row.value_old:"-" )
                                    :
                                    row.field === "secondary_driver_id" ? (
                                      row.value_old ? row.value_old:"-" )
                                    :
                                    row.field == "delivered_at" ? (
                                      row.value_old ? (
                                        moment(row.value_old).format(
                                          "DD/MMM/YY - hh:mm A"
                                        )
                                      ) : (
                                        "-"
                                      )
                                    ) : row.field == "order_status" ? (
                                      row.value_old == 2 ? (
                                        <Button
                                          variant="success"
                                          style={{
                                            backgroundColor: "#ED9704",
                                            width: "12vh",
                                            border: "none",
                                            cursor: "auto",
                                            outline: "none",
                                            boxShadow: "none",
                                            color: "#ffffff",
                                          }}
                                        >
                                          New
                                        </Button>
                                      ) : row.value_old == 3 ? (
                                        <Button
                                          variant="success"
                                          style={{
                                            backgroundColor: "#F30A0B",
                                            width: "12vh",
                                            border: "none",
                                            cursor: "auto",
                                            outline: "none",
                                            boxShadow: "none",
                                            color: "#ffffff",
                                          }}
                                        >
                                          Accepted
                                        </Button>
                                      ) : row.value_old == 4 ? (
                                        <Button
                                          variant="success"
                                          style={{
                                            backgroundColor: "#4D4C5C",
                                            width: "12vh",
                                            border: "none",
                                            cursor: "auto",
                                            outline: "none",
                                            boxShadow: "none",
                                            color: "#ffffff",
                                          }}
                                        >
                                          Packed
                                        </Button>
                                      ) : row.value_old == 5 ? (
                                        <Button
                                          variant="success"
                                          style={{
                                            backgroundColor: "#56E76F",
                                            width: "12vh",
                                            border: "none",
                                            cursor: "auto",
                                            outline: "none",
                                            boxShadow: "none",
                                            color: "#ffffff",
                                          }}
                                        >
                                          On the way
                                        </Button>
                                      ) : row.value_old == 6 ? (
                                        <Button
                                          variant="success"
                                          style={{
                                            backgroundColor: "#49A641",
                                            width: "12vh",
                                            border: "none",
                                            cursor: "auto",
                                            outline: "none",
                                            boxShadow: "none",
                                            color: "#ffffff",
                                          }}
                                        >
                                          Delivered
                                        </Button>
                                      ) : row.value_old == 7 ? (
                                        <Button
                                          variant="success"
                                          style={{
                                            backgroundColor: "#A10559",
                                            width: "12vh",
                                            border: "none",
                                            cursor: "auto",
                                            outline: "none",
                                            boxShadow: "none",
                                            color: "#ffffff",
                                          }}
                                        >
                                          Cancelled
                                        </Button>
                                      ) : row.value_old == 8 ? (
                                        <Button
                                          variant="success"
                                          style={{
                                            backgroundColor: "#7E481C",
                                            width: "12vh",
                                            border: "none",
                                            cursor: "auto",
                                            outline: "none",
                                            boxShadow: "none",
                                            color: "#ffffff",
                                          }}
                                        >
                                          Arrived
                                        </Button>
                                      ) : null
                                    ) : null}
                                  </TableCell>
                                  <TableCell align="left">
                                    {row.comment}
                                  </TableCell>
                                  <TableCell align="left">
                                    {row.store_user.first_name + ' ' + row.store_user.last_name}
                                  </TableCell>
                                  <TableCell align="left">
                                    {moment(row.createdAt).format(
                                      "DD/MMM/YY - hh:mm A"
                                    )}
                                  </TableCell>
                                </TableRow>
                              );
                            })
                          ) : (
                            <TableRow>
                              <TableCell align="center" colSpan={8}>
                                No Data
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </MTable>
                    </TableContainer>
                    <div
                      style={{
                        display: "block",
                        width: "100%",
                        height: "5px",
                      }}
                    >
                      {dialogLoading && <LinearProgress variant="query" />}
                    </div>
                    <TablePagination
                      key="normal-pagination"
                      component="div"
                      page={hisPage}
                      rowsPerPage={hisLimit}
                      rowsPerPageOptions={[5, 10, 25, 50]}
                      count={listUpdateHistories?.total}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </Paper>
                </TableContent>
              </DialogContent>
              <DialogActions>
                <Button variant="secondary">
                  <span
                    className="pl-2 pr-2"
                    onClick={() => HandleCloseUpdateSlot(false)}
                  >
                    Close
                  </span>
                </Button>
              </DialogActions>
            </Dialog>
          </HelpPageWrapper>
        </CustomModal>
      );
    }
;

const mapStateToProps = (state) => {
  return {
    orders: state.dashboardReducer.orders,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getOrders: (data) => getOrders(data, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Orders);
